    import React from "react";
    import { withRouter } from "react-router-dom";
    import {
        Container,
        Row,
        Col,
        Card,
        CardHeader,
        CardBody,
        Button,
        Modal,
        ModalHeader,
        ModalBody,
        ModalFooter,
        ListGroup,
        ListGroupItem,
        Badge,
        Input
    } from "reactstrap";
    import SimpleHeader from "./../../components/Headers/SimpleHeader.jsx";
    import ReactApexChart from "react-apexcharts";
    import { ClipLoader } from "react-spinners";
    import apis from "../../Api";
    import moment from "moment";
    import { connect } from "react-redux";
    import UserDetailModal from "../pages/modal/company/UserDetailModal.jsx";
    import UnitReportExportModal from "../pages/modal/unitreport/ExportModal.jsx";
    import PresenceModal from "../pages/modal/unitreport/PresenceModal.jsx";
    import CommentsModal from "../pages/modal/unitreport/CommentsModal.jsx";
    import PresenceHistoryModal from "../pages/modal/unitreport/PresenceHistoryModal.jsx";
    import RoleModal from "../pages/modal/unitreport/RoleModal.jsx";
    import CourseModal from "../pages/modal/unitreport/CourseModal.jsx";
    import UnitStudentsModal from "../pages/modal/unitreport/UnitStudentsModal.jsx";
    import StudentHistoryModal from "../pages/modal/unitreport/StudentHistoryModal.jsx";
    import StudentProgressModal from "../pages/modal/unitreport/StudentProgressModal.jsx";

    class ClassroomReport extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                loading: false,
                selectedCompany: "",
                overview: null,
                usersCompany: [],
                classrooms: [],
                coursesData: [],
                counts: {
                    studentsBlocked: 0,
                    studentsUnblocked: 0,
                    instructorsBlocked: 0,
                    instructorsUnblocked: 0,
                    adminsBlocked: 0,
                    adminsUnblocked: 0
                },
                presenceSummary: {
                    totalRecords: 0,
                    present: 0,
                    absent: 0,
                    usersWithPresence: 0,
                    usersWithoutPresence: 0
                },
                topCourses: [],
                presenceChart: null,
                commentsChart: null,
                showPresenceModal: false,
                showCommentsModal: false,
                presenceTimelineAll: [],
                commentsTimelineAll: [],
                presenceUsers: [],
                commentsFull: [],
                
                
                roleModalConfig: null,
                showPresenceHistoryModal: false,
                selectedPresenceUserId: null,
                presenceHistoryLoading: false,
                presenceHistoryError: null,
                presenceHistoryRecords: [],
                presenceHistorySummary: {
                    total: 0,
                    present: 0,
                    absent: 0
                },
                selectedPresenceUser: null,
                showRoleModal: false,
                showUserDetailModal: false,
                selectedUserForModal: null,
                showCourseModal: false,
                selectedCourseForModal: null,
                selectedCourseId: null,
                selectedCourseName: null,
                courseDetailsCache: {},
                courseModalLoading: false,
                courseModalError: null,
                navigatingCommentId: null,
                progressSummary: {
                    totalSeconds: 0,
                    totalMinutes: 0,
                    lessonsCount: 0,
                    sessionsCount: 0
                },
                studentsProgress: [],
                studentsProgressAll: [],
                showAllStudentsProgress: false,
                showStudentProgressModal: false,
                selectedProgressStudent: null,
                showExportModal: false,
                exportModalTitle: "",
                exportModalFields: [],
                exportModalData: [],
                exportModalFileName: "export.csv",
                exportModalError: null,
                exportModalGroupOptions: [],
                exportModalGroupSelection: "",
                exportModalSelectedIds: [],
                exportModalContext: null,
                exportModalIdKey: "id",
                hoverStudentId: null,
                exportLoading: false,
                exportError: null,
                showUnitStudentsModal: false,
                showStudentHistoryModal: false,
                // keep a minimal selected student id only; modal will fetch full data itself
                selectedHistoryStudentId: null,
                // legacy fields left for compatibility; they are no longer populated by the parent
                studentHistoryLoading: false,
                studentHistoryError: null,
                studentHistoryData: null,
                selectedHistoryStudent: null
            };

            this.loadOverview = this.loadOverview.bind(this);
            this.openRoleModal = this.openRoleModal.bind(this);
            this.openUserDetail = this.openUserDetail.bind(this);
            this.openCourseModal = this.openCourseModal.bind(this);
            this.handleOpenComment = this.handleOpenComment.bind(this);
            this.navigateToClassroom = this.navigateToClassroom.bind(this);
            this.openPresenceModal = this.openPresenceModal.bind(this);
        this.openCommentsModal = this.openCommentsModal.bind(this);
            this.openPresenceHistory = this.openPresenceHistory.bind(this);
            this.closePresenceHistoryModal = this.closePresenceHistoryModal.bind(this);
            this.openExportModal = this.openExportModal.bind(this);
            this.closeExportModal = this.closeExportModal.bind(this);
            this.toggleExportField = this.toggleExportField.bind(this);
            this.handleConfirmExport = this.handleConfirmExport.bind(this);
            this.handleExportFileNameChange = this.handleExportFileNameChange.bind(this);
            this.handlePresenceExport = this.handlePresenceExport.bind(this);
            this.handleCommentsExport = this.handleCommentsExport.bind(this);
            this.handleCourseExport = this.handleCourseExport.bind(this);
            this.handleStudentProgressExport = this.handleStudentProgressExport.bind(this);
            this.handlePresenceHistoryExport = this.handlePresenceHistoryExport.bind(this);
            this.handleViewStudentProgress = this.handleViewStudentProgress.bind(this);
            this.toggleStudentsProgressView = this.toggleStudentsProgressView.bind(this);
            this.renderStudentProgressModal = this.renderStudentProgressModal.bind(this);
        this.handleStudentHover = this.handleStudentHover.bind(this);
        this.handleStudentLeave = this.handleStudentLeave.bind(this);
            this.handleExportOverview = this.handleExportOverview.bind(this);
            this.openUnitStudentsModal = this.openUnitStudentsModal.bind(this);
            this.closeUnitStudentsModal = this.closeUnitStudentsModal.bind(this);
            this.handleOpenStudentHistory = this.handleOpenStudentHistory.bind(this);
        this.closeStudentHistoryModal = this.closeStudentHistoryModal.bind(this);
        }

        componentDidMount() {
            const companyId = this.getSelectedCompanyFromProps(this.props);
            if (companyId) {
                this.setState({ selectedCompany: companyId }, () => this.loadOverview(companyId));
            }
        }

        componentDidUpdate(prevProps) {
            const currentCompany = this.getSelectedCompanyFromProps(this.props);
            const previousCompany = this.getSelectedCompanyFromProps(prevProps);

            if (currentCompany && currentCompany !== previousCompany && currentCompany !== this.state.selectedCompany) {
                this.setState({ selectedCompany: currentCompany }, () => this.loadOverview(currentCompany));
            }
        }

        getSelectedCompanyFromProps(props) {
            const pref = props?.user?.preference?.selectcompany;
            if (pref && pref !== "") {
                return pref.toString();
            }

            const { company } = props;
            if (
                Array.isArray(company) &&
                company.length === 1 &&
                Array.isArray(company[0].items) &&
                company[0].items.length === 1
            ) {
                return company[0].items[0].value?.toString() || "";
            }

            return "";
        }

        async handleExportOverview() {
            const companyId = this.state.selectedCompany;
            if (!companyId) return;
            const acl = Number(this.props.user?.accessLevel || 0);
            if (acl < 5) {
                this.setState({ exportError: this.props.translate?.permissao_negada || 'Permissão negada.' });
                return;
            }

            try {
                this.setState({ exportLoading: true, exportError: null });
                const res = await apis.getCompanyReportOverview(companyId).catch(() => null);
                const payload = res?.data || res || {};
                const overview = payload.overview || payload;
                const usersList = Array.isArray(payload.users) ? payload.users : (Array.isArray(overview?.users?.list) ? overview.users.list : []);
                const classroomsList = Array.isArray(payload.classrooms) ? payload.classrooms : (Array.isArray(overview?.classrooms) ? overview.classrooms : []);
                const coursesList = Array.isArray(payload.courses) ? payload.courses : (Array.isArray(overview?.courses) ? overview.courses : []);
                // presence users: try multiple possible shapes
                let presenceUsersList = [];
                if (Array.isArray(overview?.presence?.users?.list)) presenceUsersList = overview.presence.users.list;
                else if (Array.isArray(overview?.presence?.users)) presenceUsersList = overview.presence.users;
                else if (Array.isArray(payload.presenceUsers)) presenceUsersList = payload.presenceUsers;
                else if (Array.isArray(payload.presence?.users?.list)) presenceUsersList = payload.presence.users.list;
                else if (Array.isArray(payload.presence?.users)) presenceUsersList = payload.presence.users;

                if ((!Array.isArray(presenceUsersList) || presenceUsersList.length === 0) && Array.isArray(this.state.presenceUsers) && this.state.presenceUsers.length > 0) {
                    presenceUsersList = this.state.presenceUsers;
                }

                let presenceTimeline = this.resolveTimelineCandidates([
                    overview?.presence?.timelineAll,
                    overview?.presence?.allTimeline,
                    overview?.presence?.fullTimeline,
                    overview?.presence?.history,
                    payload.presenceTimelineAll,
                    payload.presenceHistory,
                    payload.presenceTimeline,
                    overview?.presence?.timeline,
                    overview?.presence?.summarySeries,
                    payload.presenceTimeline
                ]);

                if ((!Array.isArray(presenceTimeline) || presenceTimeline.length === 0)) {
                    try {
                        const st = Array.isArray(this.state.presenceAllTimeline) ? this.state.presenceAllTimeline : [];
                        if (st.length > 0) presenceTimeline = st;
                        else {
                            const computed = this.getPresenceAllTimeline && this.getPresenceAllTimeline();
                            if (Array.isArray(computed) && computed.length > 0) presenceTimeline = computed;
                        }
                    } catch (_) { /* ignore */ }
                }

                // comments full: try multiple possible shapes
                let commentsFull = [];
                if (Array.isArray(overview?.comments?.list)) commentsFull = overview.comments.list;
                else if (Array.isArray(overview?.comments?.full)) commentsFull = overview.comments.full;
                else if (Array.isArray(payload.commentsFull)) commentsFull = payload.commentsFull;
                else if (Array.isArray(payload.comments)) commentsFull = payload.comments;
                else if (Array.isArray(overview?.comments)) commentsFull = overview.comments;

                // Fallback to state if API didn't include comments
                if ((!Array.isArray(commentsFull) || commentsFull.length === 0) && Array.isArray(this.state.commentsFull) && this.state.commentsFull.length > 0) {
                    commentsFull = this.state.commentsFull;
                }

                // Determine users who are currently in any classroom (by id)
                const classUserIdSet = new Set();
                const clsList = Array.isArray(classroomsList) ? classroomsList : [];
                clsList.forEach(c => {
                    if (!c || typeof c !== 'object') return;
                    const candidateKeys = ['userClass','participants','users','students','classUsers','usersList','class_users','participantsList'];
                    candidateKeys.forEach(k => {
                        const arr = c[k];
                        if (Array.isArray(arr)) {
                            arr.forEach(u => {
                                if (u === null || u === undefined) return;
                                if (typeof u === 'string' || typeof u === 'number') { classUserIdSet.add(String(u)); return; }
                                const uid = u.id ?? u.user ?? u.user_id ?? u.userid ?? u.ID ?? null;
                                if (uid !== null && uid !== undefined) classUserIdSet.add(String(uid));
                            });
                        }
                    });
                });

                // userLists
                const usersArray = Array.isArray(usersList) ? usersList : [];
                let classUsers = usersArray.filter(u => u && (u.id !== undefined && u.id !== null) && classUserIdSet.has(String(u.id)));

                // If we couldn't infer participants from classrooms, fetch authoritative list from backend
                if ((classUsers.length === 0) && companyId && apis.getUsersInClassrooms) {
                    try {
                        const inClassResp = await apis.getUsersInClassrooms(companyId).catch(() => null);
                        const remoteUsers = Array.isArray(inClassResp?.data) ? inClassResp.data : (Array.isArray(inClassResp) ? inClassResp : []);
                        if (remoteUsers.length > 0) {
                            classUsers = remoteUsers;
                        }
                    } catch (_) { /* ignore */ }
                }

                const classStudents = (Array.isArray(classUsers) ? classUsers : []).filter(u => (Number(u.accessLevel) || 0) === 4);
                const classInstructors = (Array.isArray(classUsers) ? classUsers : []).filter(u => (Number(u.accessLevel) || 0) === 3);
                const classAdmins = (Array.isArray(classUsers) ? classUsers : []).filter(u => (Number(u.accessLevel) || 0) === 5 || (Number(u.accessLevel) || 0) === 6);

                const sections = [
                    { key: 'METADATA', label: 'Metadados', selected: true, count: 1 },
                    { key: 'USERS', label: 'Usuários', selected: usersList.length > 0, count: usersList.length },
                    { key: 'CLASSROOMS', label: 'Turmas', selected: classroomsList.length > 0, count: classroomsList.length },
                    { key: 'COURSES', label: 'Cursos', selected: coursesList.length > 0, count: coursesList.length },
                    { key: 'PRESENCE_USERS', label: 'Resumo de presenças por usuário', selected: presenceUsersList.length > 0, count: presenceUsersList.length },
                    { key: 'PRESENCE_TIMELINE', label: 'Linha do tempo de presenças', selected: presenceTimeline.length > 0, count: presenceTimeline.length },
                    { key: 'COMMENTS', label: 'Comentários', selected: commentsFull.length > 0, count: commentsFull.length },
                    { key: 'CLASS_STUDENTS', label: 'Usuários em turmas · Alunos', selected: classStudents.length > 0, count: classStudents.length },
                    { key: 'CLASS_INSTRUCTORS', label: 'Usuários em turmas · Instrutores', selected: classInstructors.length > 0, count: classInstructors.length },
                    { key: 'CLASS_ADMINS', label: 'Usuários em turmas · Administradores', selected: classAdmins.length > 0, count: classAdmins.length }
                ];

                this.setState({
                    showExportModal: true,
                    exportModalTitle: this.props.translate?.exportar_geral || 'Exportar geral',
                    exportModalFields: sections,
                    // enrich payload with resolved arrays so CSV builder can use them deterministically
                    exportModalData: {
                        ...payload,
                        __presenceUsers: presenceUsersList,
                        __presenceTimeline: presenceTimeline,
                        __commentsFull: commentsFull,
                        __classUsers: classUsers,
                        __classStudents: classStudents,
                        __classInstructors: classInstructors,
                        __classAdmins: classAdmins
                    },
                    exportModalFileName: `unidade-overview-${companyId}-${moment().format('YYYYMMDD')}.csv`,
                    exportModalError: null,
                    exportLoading: false
                });

                // optional debug to inspect payload shape when requested
                try {
                    if (window && window.__SHOW_OVERVIEW_DEBUG) {
                        console.debug('OVERVIEW DEBUG: payload keys', Object.keys(payload || {}));
                        console.debug('OVERVIEW DEBUG: overview keys', Object.keys(overview || {}));
                        console.debug('OVERVIEW DEBUG: users length', Array.isArray(usersList) ? usersList.length : 0);
                        console.debug('OVERVIEW DEBUG: classrooms length', Array.isArray(classroomsList) ? classroomsList.length : 0);
                        console.debug('OVERVIEW DEBUG: presenceUsers length', Array.isArray(presenceUsersList) ? presenceUsersList.length : 0);
                        console.debug('OVERVIEW DEBUG: presenceTimeline length', Array.isArray(presenceTimeline) ? presenceTimeline.length : 0);
                        console.debug('OVERVIEW DEBUG: commentsFull length', Array.isArray(commentsFull) ? commentsFull.length : 0);
                        if (Array.isArray(classroomsList) && classroomsList.length) {
                            console.debug('OVERVIEW DEBUG: sample classroom keys', Object.keys(classroomsList[0] || {}));
                            console.debug('OVERVIEW DEBUG: sample classroom participant keys', Object.keys(classroomsList[0] || {}).filter(k => typeof classroomsList[0][k] !== 'undefined' && Array.isArray(classroomsList[0][k])));
                        }
                    }
                } catch (e) {
                    // ignore debug errors
                }
            } catch (err) {
                console.error('Erro export overview', err);
                this.setState({ exportLoading: false, exportError: this.props.translate?.erro_ao_exportar || 'Erro ao exportar.' });
            }
        }

        resolveRole(accessLevel) {
            const level = Number(accessLevel);
            if (level === 4) return { key: "student", label: "Aluno" };
            if (level === 3) return { key: "instructor", label: "Instrutor" };
            if (level === 5 || level === 6) return { key: "admin", label: "Administrador" };
            return { key: "other", label: "Usuário" };
        }

        resolveLessonTypeLabel(type) {
            const raw = type === null || type === undefined ? null : String(type).trim();
            const numeric = raw !== null ? Number(raw) : Number.NaN;
            const typeMap = {
                0: "Texto",
                1: "Texto",
                2: "Conteúdo externo",
                3: "Quiz",
                4: "Arquivo",
                5: "Vídeo"
            };

            if (!Number.isNaN(numeric) && typeMap[numeric]) {
                return typeMap[numeric];
            }

            if (raw) {
                const semanticMap = {
                    texto: "Texto",
                    html: "Texto",
                    video: "Vídeo",
                    quiz: "Quiz",
                    iframe: "Conteúdo externo",
                    embed: "Conteúdo externo"
                };
                const candidate = semanticMap[raw.toLowerCase()];
                if (candidate) {
                    return candidate;
                }
                return `Outro (${raw})`;
            }

            return "Outro";
        }

        

        decorateUsers(users = []) {
            return users.map(user => {
                const roleInfo = this.resolveRole(user.accessLevel);
                const isBlocked = Number(user.blocked) === 1;
                return {
                    ...user,
                    roleKey: roleInfo.key,
                    roleLabel: roleInfo.label,
                    isBlocked,
                    statusLabel: isBlocked ? "Bloqueado" : "Ativo"
                };
            });
        }

        decorateCourseStudents(students = []) {
            return students.map(student => {
                const isBlocked = Number(student.blocked) === 1;
                return {
                    ...student,
                    roleKey: "student",
                    roleLabel: "Aluno",
                    isBlocked,
                    statusLabel: isBlocked ? "Bloqueado" : "Ativo",
                    photo: student.photo || student.foto || null
                };
            });
        }

        buildStudentProgress(students = [], decoratedUsers = []) {
            const decoratedMap = new Map();
            decoratedUsers.forEach(user => {
                const id = user && (user.id !== undefined && user.id !== null) ? String(user.id) : null;
                if (id) {
                    decoratedMap.set(id, user);
                }
            });

            const list = Array.isArray(students) ? students : [];
            return list
                .map(student => {
                    if (!student || student.id === undefined || student.id === null) return null;
                    const id = String(student.id);
                    const decorated = decoratedMap.get(id);

                    const rawRoleKey = (decorated?.roleKey || student.roleKey || student.role || '').toString().toLowerCase();
                    if (rawRoleKey && rawRoleKey !== 'student') {
                        return null;
                    }

                    const accessLevelCandidate = [
                        student.accessLevel,
                        student.role,
                        student.level,
                        decorated?.accessLevel
                    ].find(value => value !== undefined && value !== null && String(value).trim() !== '');
                    const numericLevel = accessLevelCandidate !== undefined ? Number(accessLevelCandidate) : NaN;
                    if (!Number.isNaN(numericLevel) && numericLevel !== 4) {
                        return null;
                    }

                    const isCurrentMember = Boolean(decorated);
                    const totalSeconds = Number(student.totalSeconds) || 0;
                    const totalMinutes = Math.round(totalSeconds / 60);
                    const merged = {
                        ...student,
                        id: student.id,
                        name: student.name,
                        lastName: student.lastName,
                        email: student.email,
                        lessonsCount: Number(student.lessonsCount) || 0,
                        sessionsCount: Number(student.sessionsCount) || 0,
                        totalSeconds,
                        totalMinutes,
                        formattedDuration: this.formatDuration(totalSeconds),
                        formattedLastActivity: this.formatDateTime(student.lastActivity),
                        photo: student.photo || decorated?.photo || "/images/defaultAvatar.png",
                        roleLabel: decorated?.roleLabel || "Aluno",
                        statusLabel: decorated?.statusLabel || (Number(student.blocked) === 1 ? "Bloqueado" : "Ativo"),
                        isBlocked: decorated?.isBlocked ?? (Number(student.blocked) === 1),
                        decoratedUser: decorated || null,
                        isCurrentCompanyMember: isCurrentMember
                    };
                    return merged;
                })
                .filter(Boolean)
                .sort((a, b) => b.totalSeconds - a.totalSeconds);
        }

        mergeUsers(lists = []) {
            const map = new Map();
            lists.forEach(list => {
                if (!Array.isArray(list)) return;
                list.forEach(user => {
                    if (!user || user.id === undefined || user.id === null) return;
                    const key = String(user.id);
                    const current = map.get(key) || {};
                    map.set(key, { ...current, ...user });
                });
            });
            return Array.from(map.values());
        }

        formatDuration(totalSeconds) {
            const seconds = Number(totalSeconds) || 0;
            if (seconds <= 0) {
                return "0m";
            }

            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;
            const parts = [];

            if (hours > 0) {
                parts.push(`${hours}h`);
            }
            if (minutes > 0) {
                parts.push(`${minutes}m`);
            }
            if (hours === 0 && minutes === 0 && remainingSeconds > 0) {
                parts.push(`${remainingSeconds}s`);
            }

            return parts.join(" ") || "0m";
        }

        formatDateTime(value) {
            if (!value) {
                return null;
            }

            const parsed = moment(value);
            if (!parsed.isValid()) {
                return null;
            }

            return parsed.format("DD/MM/YYYY HH:mm");
        }

        formatShortDate(value) {
            if (!value) {
                return "Sem data";
            }

            const parsed = moment(value, ["YYYY-MM-DD", moment.ISO_8601], true);
            if (parsed.isValid()) {
                return parsed.format("DD/MM/YYYY");
            }

            const fallback = moment(value);
            return fallback.isValid() ? fallback.format("DD/MM/YYYY") : "Sem data";
        }

        


        async loadOverview(companyId) {
            if (!companyId) {
                return;
            }

            this.setState({ loading: true });

            try {
                const response = await apis.getCompanyReportOverview(companyId).catch(() => null);
                const payload = response?.data || response || {};
                const overview = payload.overview || payload;
                const usersRaw = Array.isArray(payload.users) ? payload.users : (Array.isArray(overview?.users?.list) ? overview.users.list : []);
                const classrooms = Array.isArray(payload.classrooms) ? payload.classrooms : (Array.isArray(overview?.classrooms) ? overview.classrooms : []);
                const coursesData = Array.isArray(payload.courses) ? payload.courses : (Array.isArray(overview?.courses) ? overview.courses : []);
                const presenceSummaryRaw = overview?.presence?.summary || payload.presenceSummary || {};
                const presenceTimeline = overview?.presence?.timeline || payload.presenceTimeline || [];
                const commentsTimeline = overview?.comments?.timeline || payload.commentsTimeline || [];
                const topCourses = Array.isArray(payload.topCourses) ? payload.topCourses : (Array.isArray(overview?.topCourses) ? overview.topCourses : []);
                const decoratedUsers = this.decorateUsers(usersRaw);
                const progressSummaryRaw = overview?.progress?.summary || payload.progressSummary || {};
                const studentsProgressRaw = overview?.progress?.students || payload.studentsProgress || [];

                const presenceSummary = {
                    totalRecords: Number(presenceSummaryRaw.totalRecords) || 0,
                    present: Number(presenceSummaryRaw.present) || 0,
                    absent: Number(presenceSummaryRaw.absent) || 0,
                    usersWithPresence: Number(presenceSummaryRaw.usersWithPresence) || 0,
                    usersWithoutPresence: Number(presenceSummaryRaw.usersWithoutPresence) || 0
                };

                const progressSummary = {
                    totalSeconds: Number(progressSummaryRaw.totalSeconds) || 0,
                    totalMinutes: Number(progressSummaryRaw.totalMinutes) || Math.round((Number(progressSummaryRaw.totalSeconds) || 0) / 60),
                    lessonsCount: Number(progressSummaryRaw.lessonsCount) || 0,
                    sessionsCount: Number(progressSummaryRaw.sessionsCount) || 0
                };

                const presenceTimelineAll = this.resolveTimelineCandidates([
                    overview?.presence?.timelineAll,
                    overview?.presence?.allTimeline,
                    overview?.presence?.fullTimeline,
                    overview?.presence?.history,
                    payload.presenceTimelineAll,
                    payload.presenceHistory,
                    payload.presenceTimeline,
                    presenceTimeline
                ]);

                const commentsTimelineAll = this.resolveTimelineCandidates([
                    overview?.comments?.timelineAll,
                    overview?.comments?.allTimeline,
                    overview?.comments?.fullTimeline,
                    overview?.comments?.history,
                    payload.commentsTimelineAll,
                    payload.commentsHistory,
                    payload.commentsTimeline,
                    commentsTimeline
                ]);

                const presenceUsersDetailed = Array.isArray(overview?.presence?.users?.list)
                    ? overview.presence.users.list
                    : (Array.isArray(payload.presenceUsers) ? payload.presenceUsers : []);

                const commentsFullList = Array.isArray(overview?.comments?.list)
                    ? overview.comments.list
                    : (Array.isArray(payload.commentsFull) ? payload.commentsFull : []);

                const presenceTimelineFallback = presenceTimelineAll.length > 0 ? presenceTimelineAll : (
                    Array.isArray(overview?.presence?.summarySeries) ? overview.presence.summarySeries : []
                );

                const commentsTimelineFallback = commentsTimelineAll.length > 0 ? commentsTimelineAll : (
                    Array.isArray(overview?.comments?.summarySeries) ? overview.comments.summarySeries : []
                );

                const studentsProgressAll = this.buildStudentProgress(studentsProgressRaw, decoratedUsers);
                const showAllStudentsProgress = this.state.showAllStudentsProgress;
                const studentsProgressFiltered = showAllStudentsProgress
                    ? studentsProgressAll
                    : studentsProgressAll.filter(student => student.isCurrentCompanyMember);

                this.setState({
                    overview,
                    usersCompany: decoratedUsers,
                    counts: this.buildRoleCounts(overview?.users, decoratedUsers),
                    presenceSummary,
                    topCourses,
                    presenceChart: this.buildPresenceChart(presenceTimeline.length ? presenceTimeline : presenceTimelineFallback),
                    commentsChart: this.buildCommentsChart(commentsTimeline.length ? commentsTimeline : commentsTimelineFallback),
                    classrooms: Array.isArray(classrooms) ? classrooms : [],
                    coursesData,
                    progressSummary,
                    studentsProgressAll,
                    studentsProgress: studentsProgressFiltered,
                    courseDetailsCache: {},
                    presenceTimelineAll: presenceTimelineAll.length ? presenceTimelineAll : presenceTimelineFallback,
                    commentsTimelineAll: commentsTimelineAll.length ? commentsTimelineAll : commentsTimelineFallback,
                    presenceUsers: presenceUsersDetailed,
                    commentsFull: commentsFullList,
                    loading: false
                });
            } catch (err) {
                console.error("Erro ao carregar overview da unidade:", err);
                this.setState({ loading: false });
            }
        }

        buildRoleCounts(overviewUsers, fallbackUsers) {
            if (overviewUsers) {
                return {
                    studentsBlocked: overviewUsers.studentsBlocked || 0,
                    studentsUnblocked: Math.max((overviewUsers.students || 0) - (overviewUsers.studentsBlocked || 0), 0),
                    instructorsBlocked: overviewUsers.instructorsBlocked || 0,
                    instructorsUnblocked: Math.max((overviewUsers.instructors || 0) - (overviewUsers.instructorsBlocked || 0), 0),
                    adminsBlocked: overviewUsers.adminsBlocked || 0,
                    adminsUnblocked: Math.max((overviewUsers.admins || 0) - (overviewUsers.adminsBlocked || 0), 0)
                };
            }

            const counts = {
                studentsBlocked: 0,
                studentsUnblocked: 0,
                instructorsBlocked: 0,
                instructorsUnblocked: 0,
                adminsBlocked: 0,
                adminsUnblocked: 0
            };

            fallbackUsers.forEach(u => {
                const lvl = u.accessLevel ? Number(u.accessLevel) : 0;
                const blocked = Number(u.blocked) === 1;
                if (lvl === 4) {
                    if (blocked) counts.studentsBlocked++;
                    else counts.studentsUnblocked++;
                } else if (lvl === 3) {
                    if (blocked) counts.instructorsBlocked++;
                    else counts.instructorsUnblocked++;
                } else if (lvl === 5 || lvl === 6) {
                    if (blocked) counts.adminsBlocked++;
                    else counts.adminsUnblocked++;
                }
            });

            return counts;
        }

        buildPresenceChart(timeline = []) {
            const valid = Array.isArray(timeline) ? timeline.filter(item => item && item.date) : [];
            if (valid.length === 0) return null;

            const categories = valid.map(item => moment(item.date).format("DD/MM"));
            return {
                options: {
                    chart: { type: "area", toolbar: { show: false }, foreColor: "#8898aa" },
                    dataLabels: { enabled: false },
                    stroke: { curve: "smooth", width: 3 },
                    grid: { borderColor: "#e9ecef" },
                    legend: { position: "top", horizontalAlign: "left" },
                    colors: ["#2dce89", "#f5365c"],
                    xaxis: {
                        categories,
                        labels: { style: { fontFamily: "inherit" } },
                        axisTicks: { color: "#e9ecef" },
                        axisBorder: { color: "#e9ecef" }
                    },
                    yaxis: { labels: { style: { fontFamily: "inherit" } } }
                },
                series: [
                    { name: "Presenças", data: valid.map(item => item.present || 0) },
                    { name: "Faltas", data: valid.map(item => item.absent || 0) }
                ]
            };
        }

        buildCommentsChart(timeline = []) {
            const valid = Array.isArray(timeline) ? timeline.filter(item => item && item.date) : [];
            if (valid.length === 0) return null;

            const categories = valid.map(item => moment(item.date).format("DD/MM"));
            return {
                options: {
                    chart: { type: "bar", toolbar: { show: false }, foreColor: "#8898aa" },
                    plotOptions: { bar: { columnWidth: "50%", borderRadius: 6 } },
                    dataLabels: { enabled: false },
                    grid: { borderColor: "#e9ecef" },
                    colors: ["#5e72e4"],
                    xaxis: {
                        categories,
                        labels: { style: { fontFamily: "inherit" } },
                        axisTicks: { color: "#e9ecef" },
                        axisBorder: { color: "#e9ecef" }
                    },
                    yaxis: { labels: { style: { fontFamily: "inherit" } } }
                },
                series: [
                    { name: "Comentários", data: valid.map(item => item.total || 0) }
                ]
            };
        }

        resolveTimelineCandidates(candidates = []) {
            if (!Array.isArray(candidates)) return [];

            for (const candidate of candidates) {
                if (Array.isArray(candidate) && candidate.length > 0) {
                    return candidate.filter(item => item);
                }
            }

            return [];
        }

        getPresenceAllTimeline() {
            const stored = Array.isArray(this.state.presenceTimelineAll) ? this.state.presenceTimelineAll : [];
            if (stored.length > 0) {
                return stored.filter(item => item);
            }

            const presence = this.state.overview?.presence || {};
            return this.resolveTimelineCandidates([
                presence.timelineAll,
                presence.allTimeline,
                presence.fullTimeline,
                presence.history,
                presence.timeline
            ]);
        }

        calculatePresenceTotals(timeline, summary = {}, fallbackSummary = {}) {
            const validTimeline = Array.isArray(timeline) ? timeline : [];
            const totals = validTimeline.reduce(
                (acc, item) => {
                    if (!item) return acc;
                    const present = Number(item.present ?? item.presences ?? 0) || 0;
                    const absent = Number(item.absent ?? item.absences ?? 0) || 0;
                    const total = Number(
                        item.totalRecords ??
                        item.total ??
                        item.count ??
                        (present + absent)
                    ) || 0;

                    return {
                        present: acc.present + present,
                        absent: acc.absent + absent,
                        totalRecords: acc.totalRecords + total
                    };
                },
                { present: 0, absent: 0, totalRecords: 0 }
            );

            const baseSummary = Object.keys(summary || {}).length ? summary : (fallbackSummary || {});
            const totalRecordsFallback = Number(baseSummary.totalRecords) || 0;

            if (totals.totalRecords === 0 && totalRecordsFallback) {
                totals.totalRecords = totalRecordsFallback;
            } else if (totals.totalRecords === 0) {
                totals.totalRecords = totals.present + totals.absent;
            }

            if (totals.present === 0 && Number(baseSummary.present)) {
                totals.present = Number(baseSummary.present) || totals.present;
            }

            if (totals.absent === 0 && Number(baseSummary.absent)) {
                totals.absent = Number(baseSummary.absent) || totals.absent;
            }

            const usersWithPresence = Number(
                baseSummary.usersWithPresence ??
                fallbackSummary.usersWithPresence ??
                0
            ) || 0;

            const usersWithoutPresence = Number(
                baseSummary.usersWithoutPresence ??
                fallbackSummary.usersWithoutPresence ??
                0
            ) || 0;

            const hasTimelineData = validTimeline.length > 0;

            const present = hasTimelineData ? totals.present : Number(baseSummary.present || fallbackSummary.present || 0) || totals.present;
            const absent = hasTimelineData ? totals.absent : Number(baseSummary.absent || fallbackSummary.absent || 0) || totals.absent;
            const totalRecords = hasTimelineData ? totals.totalRecords : (
                Number(baseSummary.totalRecords || fallbackSummary.totalRecords || 0) || (present + absent)
            );

            return {
                totalRecords,
                present,
                absent,
                usersWithPresence,
                usersWithoutPresence
            };
        }

        getCommentsAllTimeline() {
            const stored = Array.isArray(this.state.commentsTimelineAll) ? this.state.commentsTimelineAll : [];
            if (stored.length > 0) {
                return stored.filter(item => item);
            }

            const comments = this.state.overview?.comments || {};
            return this.resolveTimelineCandidates([
                comments.timelineAll,
                comments.allTimeline,
                comments.fullTimeline,
                comments.history,
                comments.timeline
            ]);
        }

        calculateCommentsTotals(timeline, commentsOverview = {}) {
            const validTimeline = Array.isArray(timeline) ? timeline : [];
            const totalFromTimeline = validTimeline.reduce(
                (acc, item) => acc + (Number(item?.total ?? item?.count ?? item?.value ?? 0) || 0),
                0
            );

            const total = totalFromTimeline || Number(commentsOverview.totalAll ?? commentsOverview.total ?? commentsOverview.count ?? 0) || 0;

            let participants = Number(
                commentsOverview.participantsAll ??
                commentsOverview.participants ??
                commentsOverview.uniqueParticipants ??
                commentsOverview.uniqueUsers ??
                commentsOverview.users ??
                commentsOverview.commenters ??
                0
            ) || 0;

            if (!participants && Array.isArray(commentsOverview.recent)) {
                const unique = new Set();
                commentsOverview.recent.forEach(entry => {
                    const id = entry?.user?.id;
                    if (id !== undefined && id !== null) {
                        unique.add(String(id));
                    }
                });
                participants = unique.size;
            }

        const periods = validTimeline.length || Number(commentsOverview.periods ?? commentsOverview.periodsCount ?? commentsOverview.totalPeriods ?? 0) || 0;
            const averagePerPeriod = periods > 0 ? total / periods : total;

            return {
                total,
                participants,
                periods,
                averagePerPeriod
            };
        }

        formatTimelineLabel(item) {
            if (!item || typeof item !== "object") return "Período";

            if (item.label) return item.label;
            if (item.periodLabel) return item.periodLabel;
            if (item.period) return item.period;
            if (item.range) return item.range;

            const start = item.startDate || item.start || item.periodStart;
            const end = item.endDate || item.end || item.periodEnd;

            if (start || end) {
                const startMoment = start ? moment(start) : null;
                const endMoment = end ? moment(end) : null;
                const startLabel = startMoment && startMoment.isValid() ? startMoment.format("DD/MM/YYYY") : "...";
                const endLabel = endMoment && endMoment.isValid() ? endMoment.format("DD/MM/YYYY") : "...";
                if (startLabel === endLabel) {
                    return startLabel;
                }
                return `${startLabel} - ${endLabel}`;
            }

            if (item.month && item.year) {
                const month = String(item.month).padStart(2, "0");
                return `${month}/${item.year}`;
            }

            if (item.week) {
                return `Semana ${item.week}`;
            }

            if (item.date) {
                const dateMoment = moment(item.date);
                if (dateMoment.isValid()) {
                    return dateMoment.format("DD/MM/YYYY");
                }
            }

            if (item.year && !item.month) {
                return String(item.year);
            }

            return "Período";
        }

        openPresenceModal() {
            this.setState({ showPresenceModal: true });
        }

        openCommentsModal() {
            this.setState({ showCommentsModal: true });
        }

        async openPresenceHistory(userData) {
            // Minimal parent responsibility: open the modal and pass only the student id.
            if (!userData || !userData.id) return;
            this.setState({
                showPresenceHistoryModal: true,
                selectedPresenceUserId: userData.id,
                // clear any legacy fields
                presenceHistoryLoading: false,
                presenceHistoryError: null,
                presenceHistoryRecords: [],
                presenceHistorySummary: { total: 0, present: 0, absent: 0 },
                selectedPresenceUser: null
            });
        }

        closePresenceHistoryModal() {
            this.setState({
                showPresenceHistoryModal: false,
                selectedPresenceUserId: null,
                presenceHistoryLoading: false,
                presenceHistoryError: null,
                presenceHistoryRecords: [],
                presenceHistorySummary: { total: 0, present: 0, absent: 0 },
                selectedPresenceUser: null
            });
        }

        openExportModal(config) {
            if (!config) {
                return;
            }

            const fields = Array.isArray(config.fields) ? config.fields : [];
            if (fields.length === 0) {
                return;
            }

            const data = config.data;
            const allowObjectData = data && typeof data === 'object' && !Array.isArray(data);
            if (!allowObjectData && (!Array.isArray(data) || data.length === 0)) {
                return;
            }

            const normalizedFields = fields.map(field => ({
                key: field.key,
                label: field.label,
                selected: field.selected !== undefined ? field.selected : true
            }));

            const rawGroupOptions = Array.isArray(config.groupOptions) ? config.groupOptions : [];
            const normalizedGroupOptions = rawGroupOptions
                .filter(option => option && option.value !== undefined && option.label !== undefined)
                .map(option => ({
                    value: option.value,
                    label: option.label,
                    disabled: Boolean(option.disabled)
                }));

            let groupSelection = "";
            if (normalizedGroupOptions.length > 0) {
                const requested = config.defaultGroup;
                const requestedOption = normalizedGroupOptions.find(option => option.value === requested && !option.disabled);
                if (requestedOption) {
                    groupSelection = requestedOption.value;
                } else {
                    const fallbackOption = normalizedGroupOptions.find(option => !option.disabled);
                    groupSelection = fallbackOption ? fallbackOption.value : "";
                }
            }

            const normalizedSelectedIds = Array.isArray(config.selectedIds)
                ? config.selectedIds.filter(id => id !== undefined && id !== null).map(id => String(id))
                : [];

            this.setState({
                showExportModal: true,
                exportModalTitle: config.title || "Exportar dados",
                exportModalFields: normalizedFields,
                exportModalData: data,
                exportModalFileName: config.fileName || this.generateExportFileName("export"),
                exportModalError: null,
                exportModalGroupOptions: normalizedGroupOptions,
                exportModalGroupSelection: groupSelection,
                exportModalSelectedIds: normalizedSelectedIds,
                exportModalContext: config.context || null,
                exportModalIdKey: config.idKey || "id"
            });
        }

        closeExportModal() {
            this.setState({
                showExportModal: false,
                exportModalTitle: "",
                exportModalFields: [],
                exportModalData: [],
                exportModalFileName: "export.csv",
                exportModalError: null,
                exportModalGroupOptions: [],
                exportModalGroupSelection: "",
                exportModalSelectedIds: [],
                exportModalContext: null,
                exportModalIdKey: "id"
            });
        }

        toggleExportField(fieldKey) {
            this.setState(prev => ({
                exportModalFields: prev.exportModalFields.map(field =>
                    field.key === fieldKey ? { ...field, selected: !field.selected } : field
                ),
                exportModalError: null
            }));
        }

        handleConfirmExport() {
            const selectedFields = Array.isArray(this.state.exportModalFields) ? this.state.exportModalFields.filter(f => f.selected) : [];
            if (selectedFields.length === 0) {
                this.setState({ exportModalError: "Selecione ao menos um campo para exportação." });
                return;
            }

            const data = this.state.exportModalData;
            this.setState({ exportModalError: null });

            let csvContent = "";

            if (Array.isArray(data)) {
                const scopedData = this.filterExportDataByGroup(data);
                if (!Array.isArray(scopedData) || scopedData.length === 0) {
                    this.setState({ exportModalError: "Nenhum dado disponível para o escopo selecionado." });
                    return;
                }
                csvContent = this.buildCSVContent(selectedFields, scopedData);
            } else if (data && typeof data === 'object') {
                const selectedKeys = selectedFields.map(f => f.key);
                csvContent = this.buildOverviewCsv(data, selectedKeys);
            } else {
                this.setState({ exportModalError: 'Dados inválidos para exportação.' });
                return;
            }

            let fileName = (this.state.exportModalFileName || "").trim();
            if (!fileName) fileName = this.generateExportFileName("export");
            else if (!fileName.toLowerCase().endsWith('.csv')) fileName = `${fileName}.csv`;

            this.downloadCSV(fileName, csvContent);
            this.closeExportModal();
        }

        handleCourseExport(searchTermFromModal) {
            const selectedFields = this.state.exportModalFields.filter(field => field.selected);
            if (selectedFields.length === 0) {
                this.setState({ exportModalError: "Selecione ao menos um campo para exportação." });
                return;
            }

            const data = this.state.exportModalData;

            const searchTerm = (searchTermFromModal || "").trim().toLowerCase();
            let csvContent = "";

            if (Array.isArray(data)) {
                const scopedData = this.filterExportDataByGroup(data);
                if (!Array.isArray(scopedData) || scopedData.length === 0) {
                    this.setState({ exportModalError: "Nenhum dado disponível para o escopo selecionado." });
                    return;
                }
                csvContent = this.buildCSVContent(selectedFields, scopedData);
            } else if (data && typeof data === 'object') {
                // overview/object export: selectedFields represent section keys
                let selectedKeys = selectedFields.map(f => f.key);
                // safety: if only METADATA was selected but overview contains other non-empty sections,
                // include them automatically to avoid exporting only metadata by mistake.
                if (selectedKeys.length === 1 && selectedKeys[0] === 'METADATA') {
                    const overview = data.overview || data;
                    const usersList = Array.isArray(data.users) ? data.users : (Array.isArray(overview?.users?.list) ? overview.users.list : []);
                    const classroomsList = Array.isArray(data.classrooms) ? data.classrooms : (Array.isArray(overview?.classrooms) ? overview.classrooms : []);
                    const coursesList = Array.isArray(data.courses) ? data.courses : (Array.isArray(overview?.courses) ? overview.courses : []);
                    const presenceUsersList = Array.isArray(overview?.presence?.users?.list) ? overview.presence.users.list : (Array.isArray(data.presenceUsers) ? data.presenceUsers : []);
                    const presenceTimeline = Array.isArray(overview?.presence?.timelineAll) ? overview.presence.timelineAll : (Array.isArray(data.presenceTimeline) ? data.presenceTimeline : (Array.isArray(overview?.presence?.timeline) ? overview.presence.timeline : []));
                    const commentsFull = Array.isArray(overview?.comments?.list) ? overview.comments.list : (Array.isArray(data.commentsFull) ? data.commentsFull : []);
                    const extra = [];
                    if (usersList.length > 0) extra.push('USERS');
                    if (classroomsList.length > 0) extra.push('CLASSROOMS');
                    if (coursesList.length > 0) extra.push('COURSES');
                    if (presenceUsersList.length > 0) extra.push('PRESENCE_USERS');
                    if (presenceTimeline.length > 0) extra.push('PRESENCE_TIMELINE');
                    if (commentsFull.length > 0) extra.push('COMMENTS');
                    if (extra.length > 0) selectedKeys = selectedKeys.concat(extra);
                }
                csvContent = this.buildOverviewCsv(data, selectedKeys);
            } else {
                this.setState({ exportModalError: 'Dados inválidos para exportação.' });
                return;
            }

            let fileName = (this.state.exportModalFileName || "").trim();
            if (!fileName) {
                fileName = this.generateExportFileName("export");
            } else if (!fileName.toLowerCase().endsWith(".csv")) {
                fileName = `${fileName}.csv`;
            }

            this.downloadCSV(fileName, csvContent);
            this.closeExportModal();
        }

        handleExportFileNameChange(event) {
            const value = event?.target?.value ?? "";
            this.setState({ exportModalFileName: value });
        }

        filterExportDataByGroup(data) {
            if (!Array.isArray(data)) {
                return data;
            }

            const groupOptions = Array.isArray(this.state.exportModalGroupOptions) ? this.state.exportModalGroupOptions : [];
            if (groupOptions.length === 0) {
                return data;
            }

            const selection = this.state.exportModalGroupSelection || '';
            const idKey = this.state.exportModalIdKey || 'id';
            const selectedIdsSet = new Set((Array.isArray(this.state.exportModalSelectedIds) ? this.state.exportModalSelectedIds : []).map(String));

            if (selection === 'selected') {
                return data.filter(item => item && selectedIdsSet.has(String(item?.[idKey])));
            }

            if (selection === 'in' || selection === 'out') {
                return data.filter(item => item && item.__group === selection);
            }

            return data.slice();
        }

        buildCSVContent(fields, data) {
            const header = fields.map(field => this.escapeCsvValue(field.label)).join(";");
            const rows = data.map(item =>
                fields
                    .map(field => this.escapeCsvValue(this.resolveExportValue(item[field.key])))
                    .join(";")
            );
            return [header, ...rows].join("\r\n");
        }

        escapeCsvValue(value) {
            const normalized = value === null || value === undefined ? "" : String(value);
            const escaped = normalized.replace(/"/g, "\"\"");
            return `"${escaped}"`;
        }

        resolveExportValue(value) {
            if (value === null || value === undefined) {
                return "";
            }
            if (Array.isArray(value)) {
                return value.join(", ");
            }
            if (typeof value === "object") {
                if (value instanceof Date) {
                    return moment(value).format("YYYY-MM-DD HH:mm:ss");
                }
                return JSON.stringify(value);
            }
            if (typeof value === "boolean") {
                return value ? "true" : "false";
            }
            return value;
        }

        downloadCSV(fileName, content) {
            try {
                const blob = new Blob(["\ufeff" + content], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (err) {
                console.error("Erro ao exportar CSV:", err);
            }
        }

        arrayObjectsToCsv(fields, arr) {
            const header = Array.isArray(fields) && fields.length > 0 ? fields.map(f => this.escapeCsvValue(f.label)).join(";") : "";
            if (!Array.isArray(arr) || arr.length === 0) {
                // return header only (if present) or an explicit empty marker
                if (header) return header;
                return "";
            }
            const rows = arr.map(item => fields.map(f => this.escapeCsvValue(this.resolveExportValue(item[f.key]))).join(";"));
            return [header, ...rows].join("\r\n");
        }

        buildOverviewCsv(overviewPayload, selectedKeys) {
            const sections = [];

            if (selectedKeys.includes('METADATA')) {
                const meta = [];
                meta.push(['export_date', moment().format('YYYY-MM-DD HH:mm:ss')]);
                meta.push(['company', this.state.selectedCompany || '']);
                const presence = overviewPayload.overview?.presence || overviewPayload.presence || overviewPayload || {};
                const ps = presence?.summary || overviewPayload.presenceSummary || null;
                if (ps) {
                    meta.push(['presence_total_records', ps.totalRecords ?? '']);
                    meta.push(['presence_present', ps.present ?? '']);
                    meta.push(['presence_absent', ps.absent ?? '']);
                }
                sections.push({ title: 'METADATA', csv: meta.map(r => r.map(v => this.escapeCsvValue(v)).join(';')).join('\n') });
            }

            // USERS
            if (selectedKeys.includes('USERS')) {
                const usersList = Array.isArray(overviewPayload.users) ? overviewPayload.users : (Array.isArray(overviewPayload.overview?.users?.list) ? overviewPayload.overview.users.list : []);
                if (usersList.length > 0) {
                    const userFields = this.defaultFieldsForArray(usersList).filter(f => !['photo', 'foto'].includes((f.key || '').toString().toLowerCase()));
                    sections.push({ title: 'USERS', csv: this.arrayObjectsToCsv(userFields, usersList) });
                }
            }

            // CLASSROOMS
            if (selectedKeys.includes('CLASSROOMS')) {
                const classrooms = Array.isArray(overviewPayload.classrooms) ? overviewPayload.classrooms : (Array.isArray(overviewPayload.overview?.classrooms) ? overviewPayload.overview.classrooms : []);
                if (classrooms.length > 0) sections.push({ title: 'CLASSROOMS', csv: this.arrayObjectsToCsv(this.defaultFieldsForArray(classrooms), classrooms) });
            }

            // COURSES
            if (selectedKeys.includes('COURSES')) {
                const courses = Array.isArray(overviewPayload.courses) ? overviewPayload.courses : (Array.isArray(overviewPayload.overview?.courses) ? overviewPayload.overview.courses : []);
                if (courses.length > 0) sections.push({ title: 'COURSES', csv: this.arrayObjectsToCsv(this.defaultFieldsForArray(courses), courses) });
            }

            // PRESENCE_USERS
            if (selectedKeys.includes('PRESENCE_USERS')) {
                const presenceUsers = Array.isArray(overviewPayload.__presenceUsers)
                    ? overviewPayload.__presenceUsers
                    : (Array.isArray(overviewPayload.overview?.presence?.users?.list)
                        ? overviewPayload.overview.presence.users.list
                        : (Array.isArray(overviewPayload.presenceUsers)
                            ? overviewPayload.presenceUsers
                            : []));
                if (presenceUsers.length > 0) {
                    const presFields = this.defaultFieldsForArray(presenceUsers).filter(f => !['photo', 'foto'].includes((f.key || '').toString().toLowerCase()));
                    sections.push({ title: 'PRESENCE_USERS', csv: this.arrayObjectsToCsv(presFields, presenceUsers) });
                }
            }

            // PRESENCE_TIMELINE
            if (selectedKeys.includes('PRESENCE_TIMELINE')) {
                const presenceTimeline = Array.isArray(overviewPayload.__presenceTimeline)
                    ? overviewPayload.__presenceTimeline
                    : (Array.isArray(overviewPayload.overview?.presence?.timelineAll)
                        ? overviewPayload.overview.presence.timelineAll
                        : (Array.isArray(overviewPayload.presenceTimeline)
                            ? overviewPayload.presenceTimeline
                            : (Array.isArray(overviewPayload.overview?.presence?.timeline)
                                ? overviewPayload.overview.presence.timeline
                                : [])));
                if (presenceTimeline.length > 0) sections.push({ title: 'PRESENCE_TIMELINE', csv: this.arrayObjectsToCsv(this.defaultFieldsForArray(presenceTimeline), presenceTimeline) });
            }

            // COMMENTS
            if (selectedKeys.includes('COMMENTS')) {
                const commentsFull = Array.isArray(overviewPayload.__commentsFull)
                    ? overviewPayload.__commentsFull
                    : (Array.isArray(overviewPayload.overview?.comments?.list)
                        ? overviewPayload.overview.comments.list
                        : (Array.isArray(overviewPayload.commentsFull)
                            ? overviewPayload.commentsFull
                            : []));
                if (commentsFull.length > 0) sections.push({ title: 'COMMENTS', csv: this.arrayObjectsToCsv(this.defaultFieldsForArray(commentsFull), commentsFull) });
            }
            // CLASS_STUDENTS
            if (selectedKeys.includes('CLASS_STUDENTS')) {
                const classStudents = Array.isArray(overviewPayload.__classStudents)
                    ? overviewPayload.__classStudents
                    : (function() {
                        const usersList = Array.isArray(overviewPayload.users) ? overviewPayload.users : (Array.isArray(overviewPayload.overview?.users?.list) ? overviewPayload.overview.users.list : []);
                        const clsList = Array.isArray(overviewPayload.classrooms) ? overviewPayload.classrooms : (Array.isArray(overviewPayload.overview?.classrooms) ? overviewPayload.overview.classrooms : []);
                        const classUserIdSet = new Set();
                        clsList.forEach(c => {
                            if (!c || typeof c !== 'object') return;
                            const candidateKeys = ['userClass','participants','users','students','classUsers','usersList','class_users','participantsList'];
                            candidateKeys.forEach(k => {
                                const arr = c[k];
                                if (Array.isArray(arr)) {
                                    arr.forEach(u => {
                                        if (u === null || u === undefined) return;
                                        if (typeof u === 'string' || typeof u === 'number') { classUserIdSet.add(String(u)); return; }
                                        const uid = u.id ?? u.user ?? u.user_id ?? u.userid ?? u.ID ?? null;
                                        if (uid !== null && uid !== undefined) classUserIdSet.add(String(uid));
                                    });
                                }
                            });
                        });
                        const usersArray = Array.isArray(usersList) ? usersList : [];
                        return usersArray.filter(u => u && (u.id !== undefined && u.id !== null) && classUserIdSet.has(String(u.id)) && (Number(u.accessLevel) || 0) === 4);
                    })();
                if (classStudents.length > 0) {
                    const userFields = this.defaultFieldsForArray(classStudents).filter(f => !['photo', 'foto'].includes((f.key || '').toString().toLowerCase()));
                    sections.push({ title: 'CLASS_STUDENTS', csv: this.arrayObjectsToCsv(userFields, classStudents) });
                }
            }

            // CLASS_INSTRUCTORS
            if (selectedKeys.includes('CLASS_INSTRUCTORS')) {
                const classInstructors = Array.isArray(overviewPayload.__classInstructors)
                    ? overviewPayload.__classInstructors
                    : (function() {
                        const usersList = Array.isArray(overviewPayload.users) ? overviewPayload.users : (Array.isArray(overviewPayload.overview?.users?.list) ? overviewPayload.overview.users.list : []);
                        const clsList = Array.isArray(overviewPayload.classrooms) ? overviewPayload.classrooms : (Array.isArray(overviewPayload.overview?.classrooms) ? overviewPayload.overview.classrooms : []);
                        const classUserIdSet = new Set();
                        clsList.forEach(c => {
                            if (!c || typeof c !== 'object') return;
                            const candidateKeys = ['userClass','participants','users','students','classUsers','usersList','class_users','participantsList'];
                            candidateKeys.forEach(k => {
                                const arr = c[k];
                                if (Array.isArray(arr)) {
                                    arr.forEach(u => {
                                        if (u === null || u === undefined) return;
                                        if (typeof u === 'string' || typeof u === 'number') { classUserIdSet.add(String(u)); return; }
                                        const uid = u.id ?? u.user ?? u.user_id ?? u.userid ?? u.ID ?? null;
                                        if (uid !== null && uid !== undefined) classUserIdSet.add(String(uid));
                                    });
                                }
                            });
                        });
                        const usersArray = Array.isArray(usersList) ? usersList : [];
                        return usersArray.filter(u => u && (u.id !== undefined && u.id !== null) && classUserIdSet.has(String(u.id)) && (Number(u.accessLevel) || 0) === 3);
                    })();
                if (classInstructors.length > 0) {
                    const userFields = this.defaultFieldsForArray(classInstructors).filter(f => !['photo', 'foto'].includes((f.key || '').toString().toLowerCase()));
                    sections.push({ title: 'CLASS_INSTRUCTORS', csv: this.arrayObjectsToCsv(userFields, classInstructors) });
                }
            }

            // CLASS_ADMINS
            if (selectedKeys.includes('CLASS_ADMINS')) {
                const classAdmins = Array.isArray(overviewPayload.__classAdmins)
                    ? overviewPayload.__classAdmins
                    : (function() {
                        const usersList = Array.isArray(overviewPayload.users) ? overviewPayload.users : (Array.isArray(overviewPayload.overview?.users?.list) ? overviewPayload.overview.users.list : []);
                        const clsList = Array.isArray(overviewPayload.classrooms) ? overviewPayload.classrooms : (Array.isArray(overviewPayload.overview?.classrooms) ? overviewPayload.overview.classrooms : []);
                        const classUserIdSet = new Set();
                        clsList.forEach(c => {
                            if (!c || typeof c !== 'object') return;
                            const candidateKeys = ['userClass','participants','users','students','classUsers','usersList','class_users','participantsList'];
                            candidateKeys.forEach(k => {
                                const arr = c[k];
                                if (Array.isArray(arr)) {
                                    arr.forEach(u => {
                                        if (u === null || u === undefined) return;
                                        if (typeof u === 'string' || typeof u === 'number') { classUserIdSet.add(String(u)); return; }
                                        const uid = u.id ?? u.user ?? u.user_id ?? u.userid ?? u.ID ?? null;
                                        if (uid !== null && uid !== undefined) classUserIdSet.add(String(uid));
                                    });
                                }
                            });
                        });
                        const usersArray = Array.isArray(usersList) ? usersList : [];
                        return usersArray.filter(u => u && (u.id !== undefined && u.id !== null) && classUserIdSet.has(String(u.id)) && ((Number(u.accessLevel) || 0) === 5 || (Number(u.accessLevel) || 0) === 6));
                    })();
                if (classAdmins.length > 0) {
                    const userFields = this.defaultFieldsForArray(classAdmins).filter(f => !['photo', 'foto'].includes((f.key || '').toString().toLowerCase()));
                    sections.push({ title: 'CLASS_ADMINS', csv: this.arrayObjectsToCsv(userFields, classAdmins) });
                }
            }
            

            const parts = [];
            sections.forEach(sec => {
                parts.push(`# ${sec.title}`);
                parts.push(sec.csv);
                parts.push('');
            });
            return '\ufeff' + parts.join('\n');
        }

            defaultFieldsForArray(arr) {
            if (!Array.isArray(arr) || arr.length === 0) return [];
            const keys = Array.from(arr.reduce((set, item) => { Object.keys(item || {}).forEach(k => set.add(k)); return set; }, new Set()));
            return keys.map(k => ({ key: k, label: k }));
        }

        generateExportFileName(baseName) {
            const safeBase = (baseName || "export").toString().toLowerCase().replace(/[^a-z0-9_-]+/g, "-");
            const timestamp = moment().format("YYYYMMDD-HHmmss");
            return `${safeBase}-${timestamp}.csv`;
        }

        handlePresenceExport() {
            const firstArg = arguments[0];

            if (Array.isArray(firstArg)) {
                const rows = firstArg;
                if (!rows || rows.length === 0) return;

                const fields = [
                    { key: "id", label: "ID" },
                    { key: "name", label: "Nome" },
                    { key: "lastName", label: "Sobrenome" },
                    { key: "fullName", label: "Nome completo" },
                    { key: "email", label: "E-mail" },
                    { key: "role", label: "Perfil" },
                    { key: "presences", label: "Presenças" },
                    { key: "absences", label: "Faltas" },
                    { key: "lastDate", label: "Última data (ISO)" },
                    { key: "lastDateFormatted", label: "Última data" },
                    { key: "lastStatus", label: "Último status" },
                    { key: "blocked", label: "Bloqueado" }
                ];

                this.openExportModal({
                    title: "Exportar lista de presença",
                    fields,
                    data: rows,
                    fileName: this.generateExportFileName("presencas")
                });
                return;
            }

            const presenceUsersList = Array.isArray(this.state.presenceUsers) ? this.state.presenceUsers : [];
            if (presenceUsersList.length === 0) return;

            const searchTermFromModal = firstArg;
            const searchTerm = (searchTermFromModal || "").trim().toLowerCase();
            const matchesSearch = user => {
                if (!searchTerm) return true;
                const decoratedUser = this.state.usersCompany.find(u => String(u.id) === String(user.id)) || {};
                const fields = [
                    user.name,
                    user.lastName,
                    user.email,
                    decoratedUser.name,
                    decoratedUser.lastName,
                    decoratedUser.email
                ];
                return fields
                    .filter(Boolean)
                    .map(value => value.toString().toLowerCase())
                    .some(value => value.includes(searchTerm));
            };

            const filteredUsers = presenceUsersList.filter(matchesSearch);
            if (filteredUsers.length === 0) return;

            const rows = filteredUsers.map(user => {
                const decoratedUser = this.state.usersCompany.find(u => String(u.id) === String(user.id)) || {};
                const lastDateISO = user.lastDate || "";
                const lastDateFormatted = user.lastDate ? moment(user.lastDate).format("DD/MM/YYYY") : "";
                const fullName = `${decoratedUser.name || user.name || ""} ${decoratedUser.lastName || user.lastName || ""}`.trim();
                return {
                    id: decoratedUser.id || user.id || "",
                    name: decoratedUser.name || user.name || "",
                    lastName: decoratedUser.lastName || user.lastName || "",
                    fullName,
                    email: user.email || decoratedUser.email || "",
                    role: decoratedUser.roleLabel || "",
                    presences: user.presences || 0,
                    absences: user.absences || 0,
                    lastDate: lastDateISO,
                    lastDateFormatted,
                    lastStatus: user.lastStatus || "",
                    blocked: decoratedUser.isBlocked ? "Sim" : "Não"
                };
            });

            const fields = [
                { key: "id", label: "ID" },
                { key: "name", label: "Nome" },
                { key: "lastName", label: "Sobrenome" },
                { key: "fullName", label: "Nome completo" },
                { key: "email", label: "E-mail" },
                { key: "role", label: "Perfil" },
                { key: "presences", label: "Presenças" },
                { key: "absences", label: "Faltas" },
                { key: "lastDate", label: "Última data (ISO)" },
                { key: "lastDateFormatted", label: "Última data" },
                { key: "lastStatus", label: "Último status" },
                { key: "blocked", label: "Bloqueado" }
            ];

            this.openExportModal({
                title: "Exportar lista de presença",
                fields,
                data: rows,
                fileName: this.generateExportFileName("presencas")
            });
        }

        handleCommentsExport(searchTermFromModal) {
            const commentsFull = Array.isArray(this.state.commentsFull) ? this.state.commentsFull : [];
            if (commentsFull.length === 0) {
                return;
            }

            const searchTerm = (searchTermFromModal || "").trim().toLowerCase();
            const filteredComments = commentsFull.filter(comment => {
                if (!searchTerm) return true;
                const user = comment.user || {};
                const decoratedUser = this.state.usersCompany.find(u => String(u.id) === String(user.id)) || {};
                const fields = [
                    user.name,
                    user.lastName,
                    user.email,
                    decoratedUser.name,
                    decoratedUser.lastName,
                    decoratedUser.email,
                    comment.comment,
                    comment.classroomName
                ];
                return fields
                    .filter(Boolean)
                    .map(value => value.toString().toLowerCase())
                    .some(value => value.includes(searchTerm));
            });

            if (filteredComments.length === 0) {
                return;
            }

            const rows = filteredComments.map(comment => {
                const user = comment.user || {};
                const decoratedUser = this.state.usersCompany.find(u => String(u.id) === String(user.id)) || {};
                const createdAt = comment.createDate ? moment(comment.createDate).format("YYYY-MM-DD HH:mm:ss") : "";
                const createdAtFormatted = comment.createDate ? moment(comment.createDate).format("DD/MM/YYYY HH:mm") : "";
                const fullName = `${user.name || decoratedUser.name || ""} ${user.lastName || decoratedUser.lastName || ""}`.trim();
                return {
                    commentId: comment.id,
                    userId: decoratedUser.id || user.id || "",
                    name: user.name || decoratedUser.name || "",
                    lastName: user.lastName || decoratedUser.lastName || "",
                    fullName,
                    email: user.email || decoratedUser.email || "",
                    classroomName: comment.classroomName || "",
                    comment: comment.comment || "",
                    createdAt,
                    createdAtFormatted,
                    classroomId: comment.classroom || "",
                    unitId: comment.unit || "",
                    lessonId: comment.lesson || ""
                };
            });

            const fields = [
                { key: "commentId", label: "ID do comentário" },
                { key: "userId", label: "ID do usuário" },
                { key: "name", label: "Nome" },
                { key: "lastName", label: "Sobrenome" },
                { key: "fullName", label: "Nome completo" },
                { key: "email", label: "E-mail" },
                { key: "classroomName", label: "Turma" },
                { key: "comment", label: "Comentário" },
                { key: "createdAt", label: "Data (ISO)" },
                { key: "createdAtFormatted", label: "Data" },
                { key: "classroomId", label: "ID da turma" },
                { key: "unitId", label: "ID da unit" },
                { key: "lessonId", label: "ID da aula" }
            ];

            this.openExportModal({
                title: "Exportar comentários",
                fields,
                data: rows,
                fileName: this.generateExportFileName("comentarios")
            });
        }

        

        handleCourseExport() {
            // Accept either (rowsArray) from the modal or fallback to parent state search
            const firstArg = arguments[0];
            if (Array.isArray(firstArg)) {
                const rows = firstArg;
                if (!rows || rows.length === 0) return;

                const fields = [
                    { key: "id", label: "ID" },
                    { key: "name", label: "Nome" },
                    { key: "lastName", label: "Sobrenome" },
                    { key: "email", label: "E-mail" },
                    { key: "role", label: "Perfil" },
                    { key: "status", label: "Status" },
                    { key: "blocked", label: "Bloqueado" },
                    { key: "sessionsCount", label: "Sessões" },
                    { key: "lessonsCount", label: "Aulas" },
                    { key: "totalSeconds", label: "Tempo (segundos)" },
                    { key: "totalMinutes", label: "Tempo (minutos)" },
                    { key: "formattedDuration", label: "Duração formatada" },
                    { key: "lastActivity", label: "Última atividade" }
                ];

                const courseName = this.state.selectedCourseName || "curso";
                this.openExportModal({
                    title: `Exportar alunos do curso ${courseName}`,
                    fields,
                    data: rows,
                    fileName: this.generateExportFileName(`curso-${courseName}`)
                });
                return;
            }

            // Backwards-compatible: build rows from selectedCourseForModal and courseModalSearch
            const selectedCourseForModal = this.state.selectedCourseForModal || {};
            const students = Array.isArray(selectedCourseForModal.students) ? selectedCourseForModal.students : [];
            if (students.length === 0) return;

            const searchTerm = (this.state.courseModalSearch || "").trim().toLowerCase();
            const filteredStudents = students.filter(student => {
                if (!searchTerm) return true;
                const fields = [student.name, student.lastName, student.email, student.roleLabel];
                return fields
                    .filter(Boolean)
                    .map(value => value.toString().toLowerCase())
                    .some(value => value.includes(searchTerm));
            });

            if (filteredStudents.length === 0) return;

            const rows = filteredStudents.map(student => ({
                id: student.id,
                name: student.name,
                lastName: student.lastName,
                email: student.email,
                role: student.roleLabel,
                status: student.statusLabel,
                blocked: student.isBlocked ? "Sim" : "Não",
                sessionsCount: student.sessionsCount ?? "",
                lessonsCount: student.lessonsCount ?? "",
                totalSeconds: student.totalSeconds ?? "",
                totalMinutes: student.totalMinutes ?? "",
                formattedDuration: student.formattedDuration || "",
                lastActivity: student.formattedLastActivity || ""
            }));

            const fields = [
                { key: "id", label: "ID" },
                { key: "name", label: "Nome" },
                { key: "lastName", label: "Sobrenome" },
                { key: "email", label: "E-mail" },
                { key: "role", label: "Perfil" },
                { key: "status", label: "Status" },
                { key: "blocked", label: "Bloqueado" },
                { key: "sessionsCount", label: "Sessões" },
                { key: "lessonsCount", label: "Aulas" },
                { key: "totalSeconds", label: "Tempo (segundos)" },
                { key: "totalMinutes", label: "Tempo (minutos)" },
                { key: "formattedDuration", label: "Duração formatada" },
                { key: "lastActivity", label: "Última atividade" }
            ];

            const courseName = selectedCourseForModal.name || this.state.selectedCourseName || "curso";
            this.openExportModal({
                title: `Exportar alunos do curso ${courseName}`,
                fields,
                data: rows,
                fileName: this.generateExportFileName(`curso-${courseName}`)
            });
        }

        handlePresenceHistoryExport() {
            // Accept optional records and user passed from modal; fall back to parent state for backward compatibility
            const presenceHistoryRecords = Array.isArray(arguments[0]) ? arguments[0] : (Array.isArray(this.state.presenceHistoryRecords) ? this.state.presenceHistoryRecords : []);
            const selectedUser = arguments[1] || this.state.selectedPresenceUser || null;
            if (!presenceHistoryRecords || presenceHistoryRecords.length === 0) return;

            const rows = presenceHistoryRecords.map(record => ({
                presenceListId: record.presenceListId || "",
                classroomId: record.classroomId || "",
                classroomName: record.classroomName || "",
                date: record.date || "",
                formattedDate: record.date ? moment(record.date).format("DD/MM/YYYY") : "",
                type: record.type || ""
            }));

            const fields = [
                { key: "presenceListId", label: "ID da lista" },
                { key: "classroomId", label: "ID da turma" },
                { key: "classroomName", label: "Turma" },
                { key: "date", label: "Data (ISO)" },
                { key: "formattedDate", label: "Data" },
                { key: "type", label: "Status" }
            ];

            const userName = selectedUser ? `${selectedUser.name || ""} ${selectedUser.lastName || ""}`.trim() : "usuario";
            this.openExportModal({
                title: `Exportar histórico de ${userName || "usuário"}`,
                fields,
                data: rows,
                fileName: this.generateExportFileName(`historico-${userName || "usuario"}`)
            });
        }

        openRoleModal(config) {
            // openRoleModal now delegates filtering and state to RoleModal component.
            this.setState({ showRoleModal: true, roleModalConfig: config || {} });
        }
        

        renderExportModal() {
            const {
                showExportModal,
                exportModalTitle,
                exportModalFields,
                exportModalError,
                exportModalFileName,
                exportModalGroupOptions,
                exportModalGroupSelection,
            } = this.state;

            return (
                <UnitReportExportModal
                    isOpen={Boolean(showExportModal)}
                    title={exportModalTitle}
                    fields={exportModalFields}
                    fileName={exportModalFileName}
                    groupOptions={exportModalGroupOptions}
                    groupSelection={exportModalGroupSelection}
                    error={exportModalError}
                    onClose={this.closeExportModal}
                    onConfirm={this.handleConfirmExport}
                    onFileNameChange={this.handleExportFileNameChange}
                    onGroupChange={this.handleExportGroupChange}
                    onToggleField={this.toggleExportField}
                />
            );
        }

        renderPresenceModal() {
            const { showPresenceModal, presenceSummary, presenceUsers, usersCompany } = this.state;
            if (!showPresenceModal) return null;

            const presence = this.state.overview?.presence || {};
            const timeline = this.getPresenceAllTimeline();
            const totals = this.calculatePresenceTotals(
                timeline,
                presence.summaryAll || presence.totals || presence.summary,
                presenceSummary
            );

            return (
                <PresenceModal
                    isOpen={showPresenceModal}
                    onClose={() => this.setState({ showPresenceModal: false })}
                    timeline={timeline}
                    totals={totals}
                    presenceUsers={Array.isArray(presenceUsers) ? presenceUsers : []}
                    usersCompany={Array.isArray(usersCompany) ? usersCompany : []}
                    onOpenHistory={this.openPresenceHistory}
                    onExport={this.handlePresenceExport}
                    formatTimelineLabel={(item) => this.formatTimelineLabel(item)}
                />
            );
        }

        renderCommentsModal() {
            const { showCommentsModal, navigatingCommentId } = this.state;
            const commentsOverview = this.state.overview?.comments || {};
            const timeline = this.getCommentsAllTimeline();
            const totals = this.calculateCommentsTotals(timeline, commentsOverview);
            const topClassrooms = Array.isArray(commentsOverview.byClassroom)
                ? commentsOverview.byClassroom
                : (Array.isArray(commentsOverview.topClassrooms) ? commentsOverview.topClassrooms : []);
            const topUsers = Array.isArray(commentsOverview.topUsers)
                ? commentsOverview.topUsers
                : (Array.isArray(commentsOverview.topCommenters) ? commentsOverview.topCommenters : []);
            const commentsFull = Array.isArray(this.state.commentsFull) ? this.state.commentsFull : [];

            return (
                <CommentsModal
                    isOpen={showCommentsModal}
                    onClose={() => this.setState({ showCommentsModal: false })}
                    timeline={timeline}
                    totals={totals}
                    comments={commentsFull}
                    usersCompany={this.state.usersCompany}
                    onOpenUserDetail={this.openUserDetail}
                    onOpenComment={this.handleOpenComment}
                    onNavigateToClassroom={this.navigateToClassroom}
                    navigatingCommentId={navigatingCommentId}
                    onExport={this.handleCommentsExport}
                    topClassrooms={topClassrooms}
                    topUsers={topUsers}
                    formatTimelineLabel={(item) => this.formatTimelineLabel(item)}
                />
            );
        }

        renderPresenceHistoryModal() {
            const { showPresenceHistoryModal, selectedPresenceUserId } = this.state;
            if (!showPresenceHistoryModal || !selectedPresenceUserId) return null;

            return (
                <PresenceHistoryModal
                    isOpen={Boolean(showPresenceHistoryModal)}
                    onClose={this.closePresenceHistoryModal}
                    studentId={selectedPresenceUserId}
                    companyId={this.state.selectedCompany}
                    onOpenUserDetail={this.openUserDetail}
                    onExport={this.handlePresenceHistoryExport}
                />
            );
        }

        openUserDetail(user) {
            this.setState({ selectedUserForModal: user, showUserDetailModal: true });
        }

        handleViewStudentProgress(studentSummary) {
            if (!studentSummary || !studentSummary.id) return;

            const normalized = {
                id: studentSummary.id,
                name: studentSummary.name,
                lastName: studentSummary.lastName,
                email: studentSummary.email,
                photo: studentSummary.photo || "/images/defaultAvatar.png",
                roleLabel: studentSummary.roleLabel || "Aluno",
                statusLabel: studentSummary.statusLabel || (studentSummary.isBlocked ? "Bloqueado" : "Ativo"),
                progressSummary: studentSummary.progressSummary || {
                    totalSeconds: studentSummary.totalSeconds,
                    totalMinutes: studentSummary.totalMinutes,
                    lessonsCount: studentSummary.lessonsCount,
                    sessionsCount: studentSummary.sessionsCount,
                    lastActivity: studentSummary.lastActivity || studentSummary.formattedLastActivity
                }
            };

            this.setState({
                showStudentProgressModal: true,
                selectedProgressStudent: normalized
            });
        }

        

        toggleStudentsProgressView() {
            this.setState(prevState => {
                const showAll = !prevState.showAllStudentsProgress;
                const studentsProgress = showAll
                    ? prevState.studentsProgressAll
                    : prevState.studentsProgressAll.filter(student => student.isCurrentCompanyMember);
                return {
                    showAllStudentsProgress: showAll,
                    studentsProgress
                };
            });
        }

        handleStudentHover(id) {
            this.setState({ hoverStudentId: id });
        }

        handleStudentLeave() {
            this.setState({ hoverStudentId: null });
        }

        openUnitStudentsModal() {
            this.setState({ showUnitStudentsModal: true });
        }

        closeUnitStudentsModal() {
            this.setState({ showUnitStudentsModal: false });
        }

        async handleOpenStudentHistory(student) {
            // Minimal parent responsibility: only set the selected student id and open the modal.
            if (!student || student.id === undefined || student.id === null) return;
            this.setState({
                showStudentHistoryModal: true,
                selectedHistoryStudentId: student.id
            });
        }

        closeStudentHistoryModal() {
            this.setState({
                showStudentHistoryModal: false,
                selectedHistoryStudentId: null,
                studentHistoryLoading: false,
                studentHistoryError: null,
                studentHistoryData: null,
                selectedHistoryStudent: null
            });
        }

        renderStudentProgressModal() {
            const { showStudentProgressModal, selectedProgressStudent } = this.state;
            if (!showStudentProgressModal) return null;

            return (
                <StudentProgressModal
                    isOpen={Boolean(showStudentProgressModal)}
                    onClose={() => this.setState({ showStudentProgressModal: false, selectedProgressStudent: null })}
                    selectedStudent={selectedProgressStudent}
                    companyId={this.state.selectedCompany}
                    onExport={this.handleStudentProgressExport}
                />
            );
        }

        handleStudentProgressExport() {
            // Accept rows array from modal
            const firstArg = arguments[0];
            if (!Array.isArray(firstArg) || firstArg.length === 0) return;

            const rows = firstArg;
            const fields = [
                { key: "studentId", label: "ID do aluno" },
                { key: "studentName", label: "Nome" },
                { key: "studentLastName", label: "Sobrenome" },
                { key: "studentEmail", label: "E-mail" },
                { key: "classroomId", label: "ID da turma" },
                { key: "classroomName", label: "Turma" },
                { key: "courseId", label: "ID do curso" },
                { key: "courseName", label: "Curso" },
                { key: "unitId", label: "ID da unidade" },
                { key: "unitName", label: "Unidade" },
                { key: "lessonId", label: "ID da aula" },
                { key: "lessonName", label: "Aula" },
                { key: "lessonType", label: "Tipo de aula" },
                { key: "attempts", label: "Tentativas" },
                { key: "timeSeconds", label: "Tempo (segundos)" },
                { key: "timeFormatted", label: "Tempo" },
                { key: "lastActivity", label: "Última atividade (ISO)" },
                { key: "lastActivityFormatted", label: "Última atividade" },
                { key: "quizScore", label: "Pontuação (quiz)" }
            ];

            const studentName = (rows[0] && (rows[0].studentName || "aluno")) || "aluno";
            this.openExportModal({
                title: `Exportar progresso de ${studentName}`,
                fields,
                data: rows,
                fileName: this.generateExportFileName(`progresso-${studentName}`)
            });
        }

        async openCourseModal(course) {
            if (!course) return;
            const courseId = course.id || course.course;
            if (!courseId) return;
            const courseName = course.name || course.title || "curso";
            this.setState({
                selectedCourseId: courseId,
                selectedCourseName: courseName,
                showCourseModal: true
            });
        }

        handleOpenComment(comment) {
            if (!comment || !window.comment) return;
            window.comment.open({
                classroom: comment.classroom,
                unit: comment.unit,
                lesson: comment.lesson
            });
        }

        async navigateToClassroom(comment) {
            if (!comment || !this.props.history) return;
            const classroomId = comment.classroom;
            if (!classroomId) {
                this.props.history.push("/classroom/");
                return;
            }

            this.setState({ navigatingCommentId: comment.id });

            try {
                let unitId = comment.unit;
                if (!unitId) {
                    const classroomRes = await apis.getClassRoom(classroomId).catch(() => null);
                    const courseId = classroomRes?.data?.course;
                    if (courseId) {
                        const unitsRes = await apis.getUnitsCourse(courseId).catch(() => null);
                        if (Array.isArray(unitsRes?.data) && unitsRes.data.length > 0) {
                            unitId = unitsRes.data[0].id;
                        }
                    }
                }

                if (unitId) {
                    this.props.history.push(`/classroom/dashboard/${classroomId}/${unitId}`);
                } else {
                    this.props.history.push("/classroom/");
                }
            } catch (err) {
                console.error("Erro ao navegar para a sala do comentário:", err);
            } finally {
                this.setState({ navigatingCommentId: null });
            }
        }

        renderRoleModal() {
            const { showRoleModal, roleModalTitle, roleModalConfig } = this.state;
            if (!showRoleModal) return null;

            return (
                <RoleModal
                    isOpen={Boolean(showRoleModal)}
                    onClose={() => this.setState({ showRoleModal: false, roleModalConfig: {} })}
                    title={roleModalTitle}
                    usersCompany={this.state.usersCompany}
                    classrooms={this.state.classrooms}
                    companyId={this.state.selectedCompany}
                    config={roleModalConfig || {}}
                    onOpenUserDetail={this.openUserDetail}
                    onExport={this.openExportModal}
                />
            );
        }

        renderCourseModal() {
            const { showCourseModal, selectedCourseId, selectedCourseName } = this.state;
            if (!showCourseModal || !selectedCourseId) return null;

            return (
                <CourseModal
                    isOpen={showCourseModal}
                    onClose={() => this.setState({ showCourseModal: false, selectedCourseId: null, selectedCourseName: null })}
                    courseId={selectedCourseId}
                    courseName={selectedCourseName}
                    companyId={this.state.selectedCompany}
                    onOpenUserDetail={this.openUserDetail}
                    onExport={this.handleCourseExport}
                />
            );
        }

        renderUnitStudentsModal() {
            const { showUnitStudentsModal, usersCompany, studentHistoryLoading, selectedHistoryStudentId } = this.state;
            if (!showUnitStudentsModal) return null;

            return (
                <UnitStudentsModal
                    isOpen={showUnitStudentsModal}
                    onClose={this.closeUnitStudentsModal}
                    usersCompany={usersCompany}
                    onOpenStudentHistory={this.handleOpenStudentHistory}
                    studentHistoryLoading={studentHistoryLoading}
                    activeStudentId={selectedHistoryStudentId || null}
                />
            );
        }

        renderStudentHistoryModal() {
            const { showStudentHistoryModal, selectedHistoryStudentId } = this.state;
            if (!showStudentHistoryModal || !selectedHistoryStudentId) return null;

            return (
                <StudentHistoryModal
                    isOpen={Boolean(showStudentHistoryModal)}
                    onClose={this.closeStudentHistoryModal}
                    studentId={selectedHistoryStudentId}
                    companyId={this.state.selectedCompany}
                    onOpenPresenceHistory={this.openPresenceHistory}
                    onViewStudentProgress={this.handleViewStudentProgress}
                    formatShortDate={(v) => this.formatShortDate(v)}
                    formatDateTime={(v) => this.formatDateTime(v)}
                    formatDuration={(s) => this.formatDuration(s)}
                />
            );
        }

        renderUserDetailModal() {
            const { showUserDetailModal, selectedUserForModal } = this.state;
            if (!selectedUserForModal) return null;
            return (
                <UserDetailModal
                    isOpen={showUserDetailModal}
                    toggle={() => this.setState({ showUserDetailModal: false })}
                    data={selectedUserForModal}
                />
            );
        }

        renderLoading(header) {
            return (
                <>
                    {header}
                    <Container className="mt--6" fluid>
                        <Card className="shadow">
                            <CardBody className="py-6 d-flex flex-column align-items-center justify-content-center">
                                <ClipLoader color="#5e72e4" size={48} />
                                <div className="text-muted mt-3">Carregando relatório da unidade...</div>
                            </CardBody>
                        </Card>
                    </Container>
                </>
            );
        }

        render() {
            const isAdmin = Number(this.props.user?.accessLevel || 0) >= 5;
            const headerButtons = this.state.selectedCompany && isAdmin ? (
                <Button color="primary" onClick={this.handleExportOverview} disabled={this.state.exportLoading}>
                    {this.state.exportLoading ? <ClipLoader size={14} color="#fff" /> : 'Exportar geral'}
                </Button>
            ) : null;

            const header = (
                <SimpleHeader name={this.props.translate?.relatorios || "Relatórios"} way={[{ name: this.props.translate?.relatorios || "Relatórios", url: "/report" }]} buttons={headerButtons} />
            );

            if (this.state.loading) {
                return this.renderLoading(header);
            }

            const {
                overview,
                counts,
                presenceSummary,
                topCourses,
                presenceChart,
                commentsChart,
                classrooms,
                navigatingCommentId,
                progressSummary,
                studentsProgress,
                studentsProgressAll,
                showAllStudentsProgress,
                hoverStudentId
            } = this.state;

            const totalStudentsProgress = Array.isArray(studentsProgressAll) ? studentsProgressAll.length : 0;
            const currentStudentsCount = Array.isArray(studentsProgressAll)
                ? studentsProgressAll.filter(student => student.isCurrentCompanyMember).length
                : 0;
            const formerStudentsCount = Math.max(totalStudentsProgress - currentStudentsCount, 0);
            const formerStudentsLabel = formerStudentsCount === 1 ? 'aluno' : 'alunos';

            // base visual scale on the full dataset so bars keep consistent scale
            const maxStudentSeconds = Array.isArray(studentsProgressAll) && studentsProgressAll.length
                ? Math.max(...studentsProgressAll.map(s => Number(s.totalSeconds) || 0))
                : 0;
            const maxSeconds = maxStudentSeconds > 0 ? maxStudentSeconds : 1;
            const usersOverview = overview?.users || {};
            // counts for modal filters will be computed inside renderRoleModal where modal state is available
            const commentsOverview = overview?.comments || {};
            const recentComments = Array.isArray(commentsOverview.recent) ? commentsOverview.recent : [];
            const uniqueCommenters = recentComments.reduce((set, comment) => {
                if (comment?.user?.id) {
                    set.add(comment.user.id);
                }
                return set;
            }, new Set()).size;
            const recentCommentsCount = recentComments.length;

            const roleSeries = [
                usersOverview.students || 0,
                usersOverview.instructors || 0,
                usersOverview.admins || 0
            ];
            const hasRoleData = roleSeries.some(value => value > 0);
            const roleChartOptions = {
                chart: { type: "donut" },
                labels: ["Alunos", "Instrutores", "Administradores"],
                stroke: { width: 2 },
                fill: { opacity: 1 },
                colors: ["#11cdef", "#fb6340", "#2dce89"],
                legend: { position: "bottom" },
                dataLabels: { enabled: true },
                plotOptions: { pie: { donut: { size: "50%" } } }
            };

            const topClassrooms = [...classrooms]
                .map(c => ({
                    id: c.id,
                    name: c.name,
                    countStudents: Number(c.countStudents || c.countParticipants || 0),
                    countActive: Number(c.countActive || 0)
                }))
                .sort((a, b) => b.countStudents - a.countStudents)
                .slice(0, 5);

            return (
                <>
                    {header}
                    <Container className="mt--6" fluid>
                        <Row className="mb-4">
                            <Col xl="3" lg="6" className="mb-4">
                                <Card className="card-stats shadow">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <h5 className="card-title text-uppercase text-muted mb-0">Usuários na unidade</h5>
                                                <span className="h2 font-weight-bold mb-0">{usersOverview.total || 0}</span>
                                            </Col>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
                                                    <i className="fas fa-users"></i>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mt-3 text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-success d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Usuários ativos", blocked: false })}
                                            >
                                                <i className="fas fa-check mr-1"></i>{usersOverview.active || 0} ativos
                                            </Button>
                                        </div>
                                        <div className="text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-danger d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Usuários bloqueados", blocked: true })}
                                            >
                                                <i className="fas fa-lock mr-1"></i>{usersOverview.blocked || 0} bloqueados
                                            </Button>
                                        </div>
                                        <div className="text-sm mt-2">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0"
                                                onClick={() => this.openRoleModal({ title: "Usuários na(s) turma(s)", inClassOnly: true })}
                                            >
                                                Ver todos
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="3" lg="6" className="mb-4">
                                <Card className="card-stats shadow">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <h5 className="card-title text-uppercase text-muted mb-0">Alunos</h5>
                                                <span className="h2 font-weight-bold mb-0">{(usersOverview.students || 0)}</span>
                                            </Col>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-gradient-info text-white rounded-circle shadow">
                                                    <i className="fas fa-user-graduate"></i>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mt-3 text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-success d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Alunos ativos", roles: ["student"], blocked: false })}
                                            >
                                                <i className="fas fa-check mr-1"></i>{counts.studentsUnblocked} ativos
                                            </Button>
                                        </div>
                                        <div className="text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-danger d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Alunos bloqueados", roles: ["student"], blocked: true })}
                                            >
                                                <i className="fas fa-lock mr-1"></i>{counts.studentsBlocked} bloqueados
                                            </Button>
                                        </div>
                                        <div className="text-sm mt-2">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0"
                                                onClick={() => this.openRoleModal({ title: "Alunos na(s) turma(s)", roles: ["student"], inClassOnly: true })}
                                            >
                                                Ver todos
                                            </Button>
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 ml-3 text-primary"
                                                onClick={this.openUnitStudentsModal}
                                                disabled={!this.state.selectedCompany}
                                            >
                                                Ver alunos da unidade
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="3" lg="6" className="mb-4">
                                <Card className="card-stats shadow">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <h5 className="card-title text-uppercase text-muted mb-0">Instrutores</h5>
                                                <span className="h2 font-weight-bold mb-0">{(usersOverview.instructors || 0)}</span>
                                            </Col>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-gradient-warning text-white rounded-circle shadow">
                                                    <i className="fas fa-chalkboard-teacher"></i>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mt-3 text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-success d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Instrutores ativos", roles: ["instructor"], blocked: false })}
                                            >
                                                <i className="fas fa-check mr-1"></i>{counts.instructorsUnblocked} ativos
                                            </Button>
                                        </div>
                                        <div className="text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-danger d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Instrutores bloqueados", roles: ["instructor"], blocked: true })}
                                            >
                                                <i className="fas fa-lock mr-1"></i>{counts.instructorsBlocked} bloqueados
                                            </Button>
                                        </div>
                                        <div className="text-sm mt-2">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0"
                                                onClick={() => this.openRoleModal({ title: "Instrutores na(s) turma(s)", roles: ["instructor"], inClassOnly: true })}
                                            >
                                                Ver todos
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="3" lg="6" className="mb-4">
                                <Card className="card-stats shadow">
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <h5 className="card-title text-uppercase text-muted mb-0">Administradores</h5>
                                                <span className="h2 font-weight-bold mb-0">{(usersOverview.admins || 0)}</span>
                                            </Col>
                                            <Col className="col-auto">
                                                <div className="icon icon-shape bg-gradient-success text-white rounded-circle shadow">
                                                    <i className="fas fa-user-shield"></i>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className="mt-3 text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-success d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Administradores ativos", roles: ["admin"], blocked: false })}
                                            >
                                                <i className="fas fa-check mr-1"></i>{counts.adminsUnblocked} ativos
                                            </Button>
                                        </div>
                                        <div className="text-sm">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0 text-danger d-inline-flex align-items-center"
                                                onClick={() => this.openRoleModal({ title: "Administradores bloqueados", roles: ["admin"], blocked: true })}
                                            >
                                                <i className="fas fa-lock mr-1"></i>{counts.adminsBlocked} bloqueados
                                            </Button>
                                        </div>
                                        <div className="text-sm mt-2">
                                            <Button
                                                size="sm"
                                                color="link"
                                                className="p-0"
                                                onClick={() => this.openRoleModal({ title: "Administradores na(s) turma(s)", roles: ["admin"], inClassOnly: true })}
                                            >
                                                Ver todos
                                            </Button>
                                        </div> 
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col xl="6" className="mb-4">
                                <Card className="shadow">
                                    <CardHeader className="bg-transparent d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-uppercase text-muted ls-1 mb-1">Presenças</h6>
                                            <h5 className="h3 mb-0">Participação nas últimas 4 semanas</h5>
                                        </div>
                                        <Button size="sm" color="primary" outline onClick={this.openPresenceModal}>
                                            Ver tudo
                                        </Button>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col sm="6">
                                                <div className="text-sm text-muted">Registros totais</div>
                                                <div className="h2 font-weight-bold mb-0">{presenceSummary.totalRecords}</div>
                                            </Col>
                                            <Col sm="6" className="text-sm">
                                                <div className="text-success mb-1"><i className="fas fa-check mr-1"></i>{presenceSummary.present} presenças</div>
                                                <div className="text-danger"><i className="fas fa-times mr-1"></i>{presenceSummary.absent} faltas</div>
                                            </Col>
                                        </Row>
                                        {presenceChart ? (
                                            <ReactApexChart options={presenceChart.options} series={presenceChart.series} type="area" height={260} />
                                        ) : (
                                            <div className="text-center text-muted py-5">Nenhum registro de presença encontrado neste período.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="6" className="mb-4">
                                <Card className="shadow">
                                    <CardHeader className="bg-transparent d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-uppercase text-muted ls-1 mb-1">Comentários</h6>
                                            <h5 className="h3 mb-0">Interações recentes nas turmas</h5>
                                        </div>
                                        <Button size="sm" color="primary" outline onClick={this.openCommentsModal}>
                                            Ver tudo
                                        </Button>
                                    </CardHeader>
                                    <CardBody>
                                        <Row className="mb-3">
                                            <Col sm="6">
                                                <div className="text-sm text-muted">Comentários totais</div>
                                                <div className="h2 font-weight-bold mb-0">{commentsOverview.total || 0}</div>
                                            </Col>
                                            <Col sm="6" className="text-sm">
                                                <div className="text-success mb-1"><i className="fas fa-comments mr-1"></i>{recentCommentsCount} recentes</div>
                                                <div className="text-muted"><i className="fas fa-user-friends mr-1"></i>{uniqueCommenters} participantes</div>
                                            </Col>
                                        </Row>
                                        {commentsChart ? (
                                            <ReactApexChart options={commentsChart.options} series={commentsChart.series} type="bar" height={260} />
                                        ) : (
                                            <div className="text-center text-muted py-5">Nenhum comentário registrado no período recente.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col xl="4" className="mb-4">
                                <Card className="shadow h-100">
                                    <CardHeader className="bg-transparent">
                                        <h5 className="h3 mb-0">Distribuição de perfis</h5>
                                    </CardHeader>
                                    <CardBody className="d-flex flex-column justify-content-center">
                                        {hasRoleData ? (
                                            <ReactApexChart options={roleChartOptions} series={roleSeries} type="donut" height={300} />
                                        ) : (
                                            <div className="text-center text-muted py-5">Dados insuficientes para exibir o gráfico.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="4" className="mb-4">
                                <Card className="shadow h-100">
                                    <CardHeader className="bg-transparent d-flex justify-content-between align-items-center">
                                        <h5 className="h3 mb-0">Turmas em destaque</h5>
                                        <Badge color="info" pill>{topClassrooms.length}</Badge>
                                    </CardHeader>
                                    <CardBody className="pt-0">
                                        <ListGroup flush className="mt-3">
                                            {topClassrooms.map(room => (
                                                <ListGroupItem key={room.id} className="px-0 d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <div className="font-weight-bold text-truncate" style={{ maxWidth: "180px" }}>{room.name}</div>
                                                        <div className="small text-muted">{room.countStudents} alunos · {room.countActive} ativos</div>
                                                    </div>
                                                    <Button size="sm" color="link" onClick={() => window.comment && window.comment.open({ classroom: room.id })}>Comentários</Button>
                                                </ListGroupItem>
                                            ))}
                                            {topClassrooms.length === 0 && <div className="text-center text-muted py-4">Nenhuma turma encontrada.</div>}
                                        </ListGroup>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xl="4" className="mb-4">
                                <Card className="shadow h-100">
                                    <CardHeader className="bg-transparent">
                                        <h5 className="h3 mb-0">Cursos mais utilizados</h5>
                                    </CardHeader>
                                    <CardBody className="pt-3">
                                        {topCourses.length > 0 ? (
                                            <ListGroup flush>
                                                {topCourses.map(course => (
                                                    <ListGroupItem key={course.id} className="d-flex justify-content-between align-items-center px-0">
                                                        <div>
                                                            <div className="font-weight-bold text-truncate" style={{ maxWidth: "180px" }}>{course.name}</div>
                                                            <div className="small text-muted">Alunos inscritos: {course.students}</div>
                                                        </div>
                                                        <Button size="sm" color="link" onClick={() => this.openCourseModal(course)}>Detalhar</Button>
                                                    </ListGroupItem>
                                                ))}
                                            </ListGroup>
                                        ) : (
                                            <div className="text-center text-muted py-4">Nenhum curso encontrado.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col xl="12">
                                <Card className="shadow">
                                    <CardHeader className="bg-transparent d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-uppercase text-muted ls-1 mb-1">Engajamento</h6>
                                            <h5 className="h3 mb-0">Tempo de estudo dos alunos</h5>
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap justify-content-end">
                                            <Badge color="success" pill className="mr-2">
                                                {this.formatDuration(progressSummary?.totalSeconds || 0)} totais
                                            </Badge>
                                            <Badge color="info" pill>
                                                {studentsProgress.length} alunos
                                            </Badge>
                                            {!showAllStudentsProgress && formerStudentsCount > 0 ? (
                                                <Badge color="warning" pill className="ml-2 mt-2 mt-sm-0">
                                                    Total histórico: {totalStudentsProgress}
                                                </Badge>
                                            ) : null}
                                            <Button
                                                size="sm"
                                                color={showAllStudentsProgress ? "secondary" : "primary"}
                                                outline
                                                className="ml-2 mt-2 mt-sm-0 text-left"
                                                onClick={this.toggleStudentsProgressView}
                                            >
                                                {showAllStudentsProgress
                                                    ? "Ver apenas quem está na unidade"
                                                    : "Ver todos (incluindo os que não estão mais na unidade)"}
                                            </Button>
                                        </div>
                                    </CardHeader>
                                    <CardBody>
                                        {!showAllStudentsProgress && formerStudentsCount > 0 ? (
                                            <div className="small text-muted mb-3">
                                                Exibindo {studentsProgress.length} de {totalStudentsProgress} alunos com progresso nesta unidade.
                                                Há {formerStudentsCount} {formerStudentsLabel} com registros que não pertencem mais à unidade.
                                            </div>
                                        ) : null}
                                        {showAllStudentsProgress && formerStudentsCount > 0 ? (
                                            <div className="small text-muted mb-3">
                                                Exibindo todos os {totalStudentsProgress} alunos com progresso registrado, incluindo {formerStudentsCount} {formerStudentsLabel} que não pertencem mais à unidade.
                                            </div>
                                        ) : null}
                                        {studentsProgress.length > 0 ? (
                                            <ListGroup flush>
                                                {studentsProgress.map((student, index) => {
                                                    const decoratedUser = student.decoratedUser || this.state.usersCompany.find(u => String(u.id) === String(student.id)) || {};
                                                    const detailData = {
                                                        ...decoratedUser,
                                                        id: decoratedUser.id || student.id,
                                                        name: decoratedUser.name || student.name,
                                                        lastName: decoratedUser.lastName || student.lastName,
                                                        email: decoratedUser.email || student.email,
                                                        photo: decoratedUser.photo || student.photo,
                                                        progressSummary: {
                                                            totalSeconds: student.totalSeconds,
                                                            totalMinutes: student.totalMinutes,
                                                            lessonsCount: student.lessonsCount,
                                                            sessionsCount: student.sessionsCount,
                                                            lastActivity: student.formattedLastActivity
                                                        }
                                                    };

                                                    const percent = Math.round(((Number(student.totalSeconds) || 0) / maxSeconds) * 100);
                                                    const isHover = String(hoverStudentId) === String(student.id);

                                                    return (
                                                        <ListGroupItem
                                                            key={student.id}
                                                            className={`py-3 mb-2 rounded ${isHover ? 'shadow-sm' : ''}`}
                                                            onMouseEnter={() => this.handleStudentHover(student.id)}
                                                            onMouseLeave={this.handleStudentLeave}
                                                            style={{ cursor: 'pointer', transition: 'transform 150ms, box-shadow 150ms', transform: isHover ? 'translateY(-3px)' : 'none' }}
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <div className="mr-3 text-muted font-weight-bold" style={{ width: "28px" }}>{index + 1}</div>
                                                                <div className="mr-3" style={{ width: "48px", height: "48px", borderRadius: "50%", overflow: "hidden" }}>
                                                                    <img src={student.photo || "/images/defaultAvatar.png"} alt="avatar" className="rounded-circle" style={{ width: "48px", height: "48px", objectFit: "cover" }} />
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="font-weight-bold d-flex align-items-center">
                                                                        <span className="mr-2">{student.name} {student.lastName}</span>
                                                                        <Badge color={student.isBlocked ? "danger" : "primary"} pill>{student.roleLabel}</Badge>
                                                                        {!student.isCurrentCompanyMember ? (
                                                                            <Badge color="secondary" pill className="ml-2">Fora da unidade</Badge>
                                                                        ) : null}
                                                                    </div>
                                                                    <div className="small text-muted">{student.email || "Sem e-mail"}</div>
                                                                    <div className="small text-muted">
                                                                        {student.sessionsCount} registros • {student.lessonsCount} aulas • {student.formattedDuration}
                                                                    </div>
                                                                    {student.formattedLastActivity ? (
                                                                        <div className="small text-muted">Última atividade: {student.formattedLastActivity}</div>
                                                                    ) : null}
                                                                </div>
                                                                <Button size="sm" color="primary" onClick={() => this.handleViewStudentProgress(detailData)}>Ver progresso</Button>
                                                            </div>

                                                            <div className="d-flex align-items-center mt-3">
                                                                <div className="progress flex-grow-1" style={{ height: 8, borderRadius: 6, overflow: 'hidden' }}>
                                                                    <div className="progress-bar" role="progressbar" style={{ width: `${percent}%` }} aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                                <div className="ml-3 text-sm text-muted" style={{ minWidth: 46, textAlign: 'right' }}>{percent}%</div>
                                                            </div>
                                                        </ListGroupItem>
                                                    );
                                                })}
                                            </ListGroup>
                                        ) : (
                                            <div className="text-center text-muted py-4">Nenhum progresso registrado para os alunos desta unidade.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="mb-4">
                            <Col xl="12">
                                <Card className="shadow">
                                    <CardHeader className="bg-transparent d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-uppercase text-muted ls-1 mb-1">Interações</h6>
                                            <h5 className="h3 mb-0">Comentários recentes</h5>
                                        </div>
                                        <Badge color="primary" pill>{recentComments.length}</Badge>
                                    </CardHeader>
                                    <CardBody>
                                        {recentComments.length > 0 ? (
                                            <ListGroup flush>
                                                {recentComments.map(comment => (
                                                    <ListGroupItem key={comment.id} className="py-3">
                                                        <div className="d-flex">
                                                            <div className="mr-3" style={{ width: "48px", height: "48px", borderRadius: "50%", overflow: "hidden" }}>
                                                                <img src={comment.user?.photo || "/images/defaultAvatar.png"} alt={comment.user?.name || "Usuário"} className="rounded-circle" style={{ width: "48px", height: "48px", objectFit: "cover" }} />
                                                            </div>
                                                            <div className="flex-grow-1">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div>
                                                                        <div className="font-weight-bold">{comment.user?.name} {comment.user?.lastName}</div>
                                                                        <div className="small text-muted">{moment(comment.createDate).format("DD/MM/YYYY HH:mm")}</div>
                                                                    </div>
                                                                    <div>
                                                                        {comment.classroomName ? (
                                                                            <Badge color="info" pill className="mr-2">{comment.classroomName}</Badge>
                                                                        ) : (
                                                                            <Badge color="secondary" pill className="mr-2">Comentário geral</Badge>
                                                                        )}
                                                                        <Button size="sm" color="primary" outline className="mr-2" onClick={() => this.handleOpenComment(comment)}>
                                                                            Ver comentário
                                                                        </Button>
                                                                        <Button size="sm" color="primary" onClick={() => this.navigateToClassroom(comment)}>
                                                                            {navigatingCommentId === comment.id ? <ClipLoader color="#fff" size={16} /> : "Ir para a sala"}
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2 text-sm text-muted" style={{ whiteSpace: "pre-line" }}>
                                                                    {(comment.comment || "").length > 200 ? `${comment.comment.substring(0, 200)}...` : (comment.comment || "Sem conteúdo.")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ListGroupItem>
                                                ))}
                                            </ListGroup>
                                        ) : (
                                            <div className="text-center text-muted py-5">Nenhum comentário disponível para esta unidade.</div>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        {this.renderPresenceModal()}
                        {this.renderPresenceHistoryModal()}
                        {this.renderCommentsModal()}
                        {this.renderRoleModal()}
                        {this.renderCourseModal()}
                        {this.renderExportModal()}
                        {this.renderUnitStudentsModal()}
                        {this.renderStudentHistoryModal()}
                        {this.renderStudentProgressModal()}
                        {this.renderUserDetailModal()}
                    </Container>
                </>
            );
        }
    }

    const mapStateToProps = state => ({
        company: state.company,
        user: state.user,
        translate: state.translate
    });

    export default connect(mapStateToProps)(withRouter(ClassroomReport));
